(function(){"use strict";try{if(typeof document<"u"){var t=document.createElement("style");t.appendChild(document.createTextNode(`@charset "UTF-8";.widget-button{cursor:pointer;font-weight:700;letter-spacing:normal;font-family:Roboto,Helvetica Neue,Arial,sans-serif;text-decoration:none;font-size:17px;box-shadow:"rgba(0, 0, 0, 0.24) 0px 3px 8px"}.res-form-container{max-width:325px;display:flex;flex-direction:column;align-items:center;font-family:Roboto,Helvetica Neue,Arial,sans-serif;box-sizing:border-box}.res-form-container *,.res-form-container *:before,.res-form-container *:after{box-sizing:border-box}.res-form-container select,.res-form-container input,.res-form-container button{text-shadow:none!important;text-transform:none!important;letter-spacing:normal!important;-webkit-appearance:none;-moz-appearance:none;appearance:none}.res-form-container select:hover,.res-form-container select:focus,.res-form-container input:hover,.res-form-container input:focus,.res-form-container button:hover,.res-form-container button:focus{box-shadow:none!important;text-shadow:none!important;transform:none!important;filter:none!important;text-decoration:none!important}.res-form-container select{background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'><path fill='%23565656' d='M1.5 1.5L6 6l4.5-4.5'/></svg>");background-repeat:no-repeat;background-position:right 12px center;padding-right:32px!important}.res-form-container>button{margin-top:1rem}.res-form-title{font-size:20px;margin-bottom:20px}.res-form-date-time-container{display:flex;align-items:stretch;gap:10px;margin-bottom:1rem;width:100%}.res-form-date-time-container .calendar-picker{flex:2 1 0;min-width:0;display:flex}.res-form-date-time-container .cal-trigger{width:100%!important;height:40px!important;margin:0!important;border:1px solid #e3e3e3!important;border-radius:4px!important;font-size:15px!important;line-height:1.2!important;color:#565656!important;background-color:#fff!important;padding:0 12px!important;box-sizing:border-box!important;font-family:Roboto,Helvetica Neue,Arial,sans-serif}.res-form-date-time-container .res-form-input{flex:1 1 0;min-width:0}.res-form-input{display:block!important;line-height:1.2!important;font-size:15px!important;border:1px solid #e3e3e3!important;border-radius:4px!important;color:#565656!important;padding:0 12px!important;height:40px!important;width:100%!important;background-color:#fff!important;box-sizing:border-box!important;font-family:Roboto,Helvetica Neue,Arial,sans-serif;margin:0!important;vertical-align:middle!important}.res-form-input[type=date]{padding:0 12px!important}.Modal{position:absolute;top:0;left:0;right:0;z-index:1001px;bottom:0}.Overlay{position:fixed;top:0;left:0;right:0;bottom:0;z-index:1000;background-color:#000c;overflow:hidden}.modal-title{color:#fff;font-size:20px;font-family:Poppins}.modal-footer-text{color:#fff;font-size:16px;font-family:Poppins}.ReactModal__Body--open{overflow:hidden}.calendar-picker{position:relative;display:inline-block}.calendar-picker--portal{display:contents}.calendar-picker table,.calendar-picker tbody,.calendar-picker tr,.calendar-picker td,.calendar-picker th{border:0!important;background:transparent!important;padding:0!important;margin:0!important;box-shadow:none!important;vertical-align:middle!important;float:none!important;clear:none!important;height:auto!important}.calendar-picker table.cal-grid{display:table!important;width:100%!important;table-layout:fixed!important}.calendar-picker table.cal-grid>tbody{display:table-row-group!important}.calendar-picker table.cal-grid>tbody>tr{display:table-row!important}.calendar-picker table.cal-grid>tbody>tr>td{display:table-cell!important;width:14.2857142857%!important}.calendar-picker button{text-shadow:none!important;text-transform:none!important;letter-spacing:normal!important;-webkit-appearance:none;-moz-appearance:none;appearance:none}.calendar-picker button:hover,.calendar-picker button:focus{box-shadow:none!important;text-shadow:none!important;transform:none!important;filter:none!important;text-decoration:none!important}.cal-trigger{box-sizing:border-box;display:inline-flex;align-items:center;gap:8px;height:40px;padding:8px 12px;border:1px solid #adadad;border-radius:4px;background:#fff;font-size:16px;line-height:1.42857143;color:#565656;cursor:pointer;width:200px;max-width:100%;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.cal-trigger:focus-visible{outline:none;border-color:#66afe9;box-shadow:inset 0 1px 1px #00000013,0 0 6px #66afe999}.cal-trigger-icon{display:inline-flex;color:#555;line-height:0}.cal-trigger-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cal-backdrop{display:none}.cal-picker{position:fixed;top:0;left:0;z-index:2147483647;background:#fff;border-radius:10px;box-shadow:0 8px 32px #00000026,0 2px 8px #00000014;padding:16px;width:300px;-webkit-user-select:none;user-select:none}.cal-header{display:flex;align-items:center;justify-content:space-between;margin-bottom:12px}.cal-month-year{font-size:16px;font-weight:600;color:#323232}.cal-nav-btn{display:flex;align-items:center;justify-content:center;width:36px;height:36px;min-width:36px;border:none;background:#f0f2f5;border-radius:50%;font-size:22px;line-height:1;color:#323232;cursor:pointer;transition:background .15s ease,transform .1s ease}.cal-nav-btn:active{transform:scale(.92)}.cal-nav-btn--prev,.cal-nav-btn--next{border-radius:50%}.cal-weekdays{display:grid;grid-template-columns:repeat(7,1fr);margin-bottom:4px}.cal-weekday{text-align:center;font-size:12px;font-weight:600;color:#888;padding:6px 0;text-transform:uppercase;letter-spacing:.5px}.cal-grid{width:100%;border-collapse:collapse;table-layout:fixed}.cal-day{text-align:center;padding:0}.cal-day--today .cal-day-btn{background:#e8edf7;border-radius:50%;font-weight:600}.cal-day--selected .cal-day-btn{background:#5472d3!important;color:#fff!important;border-color:#5472d3!important;box-shadow:0 2px 6px #5472d359}.cal-day--selected .cal-day-btn:hover{background:#4a66c4!important}.cal-day--disabled .cal-day-btn{color:#ccc!important;cursor:not-allowed;background:transparent!important}.cal-day--disabled .cal-day-btn:active{transform:none}.cal-day-btn{display:flex;align-items:center;justify-content:center;width:36px;height:36px;min-width:36px;margin:0 auto;border:none;background:transparent;font-size:14px;color:#323232!important;cursor:pointer;border-radius:50%;transition:background .15s ease,transform .1s ease}.cal-day-btn:active{transform:scale(.9)}.cal-day-btn:hover:not(:disabled){background:#f0f2f5!important;color:#323232!important}.cal-day-btn:focus-visible{outline:2px solid #5472d3;outline-offset:-2px}.cal-day-btn:disabled{cursor:not-allowed}@media (max-width: 767px){.cal-backdrop{display:block;position:fixed;top:0;right:0;bottom:0;left:0;background:#0006;z-index:2147483646;animation:fadeInBackdrop .2s ease-out}.cal-picker{position:fixed;top:auto!important;left:0!important;right:0!important;bottom:0!important;width:100%!important;max-width:100%;border-radius:16px 16px 0 0;padding:20px 16px 32px;box-shadow:0 -4px 24px #00000026;animation:slideUpCalendar .25s ease-out;padding-bottom:calc(32px + env(safe-area-inset-bottom))}.cal-trigger{width:100%}.cal-day-btn{width:42px;height:42px;font-size:15px}.cal-nav-btn{width:44px;height:44px;min-width:44px;font-size:26px}}@keyframes slideUpCalendar{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes fadeInBackdrop{0%{opacity:0}to{opacity:1}}`)),document.head.appendChild(t)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import At, { useState as ke, useRef as dn, useCallback as er, useEffect as xe, useMemo as pn } from "react";
import tr, { createPortal as nr } from "react-dom";
var rr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Fn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function ar(e) {
  if (e.__esModule) return e;
  var n = e.default;
  if (typeof n == "function") {
    var r = function o() {
      return this instanceof o ? Reflect.construct(n, arguments, this.constructor) : n.apply(this, arguments);
    };
    r.prototype = n.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(o) {
    var u = Object.getOwnPropertyDescriptor(e, o);
    Object.defineProperty(r, o, u.get ? u : {
      enumerable: !0,
      get: function() {
        return e[o];
      }
    });
  }), r;
}
var Xt = { exports: {} }, ct = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vn;
function or() {
  if (vn) return ct;
  vn = 1;
  var e = At, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, u = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, f = { key: !0, ref: !0, __self: !0, __source: !0 };
  function b(l, g, O) {
    var v, C = {}, E = null, D = null;
    O !== void 0 && (E = "" + O), g.key !== void 0 && (E = "" + g.key), g.ref !== void 0 && (D = g.ref);
    for (v in g) o.call(g, v) && !f.hasOwnProperty(v) && (C[v] = g[v]);
    if (l && l.defaultProps) for (v in g = l.defaultProps, g) C[v] === void 0 && (C[v] = g[v]);
    return { $$typeof: n, type: l, key: E, ref: D, props: C, _owner: u.current };
  }
  return ct.Fragment = r, ct.jsx = b, ct.jsxs = b, ct;
}
var ft = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yn;
function ir() {
  return yn || (yn = 1, process.env.NODE_ENV !== "production" && function() {
    var e = At, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), b = Symbol.for("react.provider"), l = Symbol.for("react.context"), g = Symbol.for("react.forward_ref"), O = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), C = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), D = Symbol.for("react.offscreen"), L = Symbol.iterator, A = "@@iterator";
    function Y(a) {
      if (a === null || typeof a != "object")
        return null;
      var P = L && a[L] || a[A];
      return typeof P == "function" ? P : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function te(a) {
      {
        for (var P = arguments.length, V = new Array(P > 1 ? P - 1 : 0), Z = 1; Z < P; Z++)
          V[Z - 1] = arguments[Z];
        J("error", a, V);
      }
    }
    function J(a, P, V) {
      {
        var Z = j.ReactDebugCurrentFrame, ue = Z.getStackAddendum();
        ue !== "" && (P += "%s", V = V.concat([ue]));
        var de = V.map(function(ie) {
          return String(ie);
        });
        de.unshift("Warning: " + P), Function.prototype.apply.call(console[a], console, de);
      }
    }
    var N = !1, m = !1, X = !1, G = !1, q = !1, re;
    re = Symbol.for("react.module.reference");
    function le(a) {
      return !!(typeof a == "string" || typeof a == "function" || a === o || a === f || q || a === u || a === O || a === v || G || a === D || N || m || X || typeof a == "object" && a !== null && (a.$$typeof === E || a.$$typeof === C || a.$$typeof === b || a.$$typeof === l || a.$$typeof === g || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      a.$$typeof === re || a.getModuleId !== void 0));
    }
    function ye(a, P, V) {
      var Z = a.displayName;
      if (Z)
        return Z;
      var ue = P.displayName || P.name || "";
      return ue !== "" ? V + "(" + ue + ")" : V;
    }
    function ce(a) {
      return a.displayName || "Context";
    }
    function fe(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && te("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case o:
          return "Fragment";
        case r:
          return "Portal";
        case f:
          return "Profiler";
        case u:
          return "StrictMode";
        case O:
          return "Suspense";
        case v:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case l:
            var P = a;
            return ce(P) + ".Consumer";
          case b:
            var V = a;
            return ce(V._context) + ".Provider";
          case g:
            return ye(a, a.render, "ForwardRef");
          case C:
            var Z = a.displayName || null;
            return Z !== null ? Z : fe(a.type) || "Memo";
          case E: {
            var ue = a, de = ue._payload, ie = ue._init;
            try {
              return fe(ie(de));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, H = 0, K, y, U, $, i, h, d;
    function S() {
    }
    S.__reactDisabledLog = !0;
    function M() {
      {
        if (H === 0) {
          K = console.log, y = console.info, U = console.warn, $ = console.error, i = console.group, h = console.groupCollapsed, d = console.groupEnd;
          var a = {
            configurable: !0,
            enumerable: !0,
            value: S,
            writable: !0
          };
          Object.defineProperties(console, {
            info: a,
            log: a,
            warn: a,
            error: a,
            group: a,
            groupCollapsed: a,
            groupEnd: a
          });
        }
        H++;
      }
    }
    function I() {
      {
        if (H--, H === 0) {
          var a = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, a, {
              value: K
            }),
            info: z({}, a, {
              value: y
            }),
            warn: z({}, a, {
              value: U
            }),
            error: z({}, a, {
              value: $
            }),
            group: z({}, a, {
              value: i
            }),
            groupCollapsed: z({}, a, {
              value: h
            }),
            groupEnd: z({}, a, {
              value: d
            })
          });
        }
        H < 0 && te("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var k = j.ReactCurrentDispatcher, s;
    function p(a, P, V) {
      {
        if (s === void 0)
          try {
            throw Error();
          } catch (ue) {
            var Z = ue.stack.trim().match(/\n( *(at )?)/);
            s = Z && Z[1] || "";
          }
        return `
` + s + a;
      }
    }
    var R = !1, T;
    {
      var F = typeof WeakMap == "function" ? WeakMap : Map;
      T = new F();
    }
    function w(a, P) {
      if (!a || R)
        return "";
      {
        var V = T.get(a);
        if (V !== void 0)
          return V;
      }
      var Z;
      R = !0;
      var ue = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var de;
      de = k.current, k.current = null, M();
      try {
        if (P) {
          var ie = function() {
            throw Error();
          };
          if (Object.defineProperty(ie.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ie, []);
            } catch (Q) {
              Z = Q;
            }
            Reflect.construct(a, [], ie);
          } else {
            try {
              ie.call();
            } catch (Q) {
              Z = Q;
            }
            a.call(ie.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Q) {
            Z = Q;
          }
          a();
        }
      } catch (Q) {
        if (Q && Z && typeof Q.stack == "string") {
          for (var t = Q.stack.split(`
`), c = Z.stack.split(`
`), x = t.length - 1, _ = c.length - 1; x >= 1 && _ >= 0 && t[x] !== c[_]; )
            _--;
          for (; x >= 1 && _ >= 0; x--, _--)
            if (t[x] !== c[_]) {
              if (x !== 1 || _ !== 1)
                do
                  if (x--, _--, _ < 0 || t[x] !== c[_]) {
                    var W = `
` + t[x].replace(" at new ", " at ");
                    return a.displayName && W.includes("<anonymous>") && (W = W.replace("<anonymous>", a.displayName)), typeof a == "function" && T.set(a, W), W;
                  }
                while (x >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        R = !1, k.current = de, I(), Error.prepareStackTrace = ue;
      }
      var se = a ? a.displayName || a.name : "", ne = se ? p(se) : "";
      return typeof a == "function" && T.set(a, ne), ne;
    }
    function ae(a, P, V) {
      return w(a, !1);
    }
    function oe(a) {
      var P = a.prototype;
      return !!(P && P.isReactComponent);
    }
    function me(a, P, V) {
      if (a == null)
        return "";
      if (typeof a == "function")
        return w(a, oe(a));
      if (typeof a == "string")
        return p(a);
      switch (a) {
        case O:
          return p("Suspense");
        case v:
          return p("SuspenseList");
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case g:
            return ae(a.render);
          case C:
            return me(a.type, P, V);
          case E: {
            var Z = a, ue = Z._payload, de = Z._init;
            try {
              return me(de(ue), P, V);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, je = {}, Me = j.ReactDebugCurrentFrame;
    function Fe(a) {
      if (a) {
        var P = a._owner, V = me(a.type, a._source, P ? P.type : null);
        Me.setExtraStackFrame(V);
      } else
        Me.setExtraStackFrame(null);
    }
    function Dt(a, P, V, Z, ue) {
      {
        var de = Function.call.bind(he);
        for (var ie in a)
          if (de(a, ie)) {
            var t = void 0;
            try {
              if (typeof a[ie] != "function") {
                var c = Error((Z || "React class") + ": " + V + " type `" + ie + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[ie] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw c.name = "Invariant Violation", c;
              }
              t = a[ie](P, ie, Z, V, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              t = x;
            }
            t && !(t instanceof Error) && (Fe(ue), te("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Z || "React class", V, ie, typeof t), Fe(null)), t instanceof Error && !(t.message in je) && (je[t.message] = !0, Fe(ue), te("Failed %s type: %s", V, t.message), Fe(null));
          }
      }
    }
    var kt = Array.isArray;
    function Be(a) {
      return kt(a);
    }
    function Nt(a) {
      {
        var P = typeof Symbol == "function" && Symbol.toStringTag, V = P && a[Symbol.toStringTag] || a.constructor.name || "Object";
        return V;
      }
    }
    function yt(a) {
      try {
        return mt(a), !1;
      } catch {
        return !0;
      }
    }
    function mt(a) {
      return "" + a;
    }
    function Ie(a) {
      if (yt(a))
        return te("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Nt(a)), mt(a);
    }
    var et = j.ReactCurrentOwner, ht = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ke, Je;
    function tt(a) {
      if (he.call(a, "ref")) {
        var P = Object.getOwnPropertyDescriptor(a, "ref").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return a.ref !== void 0;
    }
    function $t(a) {
      if (he.call(a, "key")) {
        var P = Object.getOwnPropertyDescriptor(a, "key").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return a.key !== void 0;
    }
    function Ft(a, P) {
      typeof a.ref == "string" && et.current;
    }
    function It(a, P) {
      {
        var V = function() {
          Ke || (Ke = !0, te("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        V.isReactWarning = !0, Object.defineProperty(a, "key", {
          get: V,
          configurable: !0
        });
      }
    }
    function nt(a, P) {
      {
        var V = function() {
          Je || (Je = !0, te("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        V.isReactWarning = !0, Object.defineProperty(a, "ref", {
          get: V,
          configurable: !0
        });
      }
    }
    var Lt = function(a, P, V, Z, ue, de, ie) {
      var t = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: a,
        key: P,
        ref: V,
        props: ie,
        // Record the component responsible for creating this element.
        _owner: de
      };
      return t._store = {}, Object.defineProperty(t._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(t, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Z
      }), Object.defineProperty(t, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ue
      }), Object.freeze && (Object.freeze(t.props), Object.freeze(t)), t;
    };
    function Wt(a, P, V, Z, ue) {
      {
        var de, ie = {}, t = null, c = null;
        V !== void 0 && (Ie(V), t = "" + V), $t(P) && (Ie(P.key), t = "" + P.key), tt(P) && (c = P.ref, Ft(P, ue));
        for (de in P)
          he.call(P, de) && !ht.hasOwnProperty(de) && (ie[de] = P[de]);
        if (a && a.defaultProps) {
          var x = a.defaultProps;
          for (de in x)
            ie[de] === void 0 && (ie[de] = x[de]);
        }
        if (t || c) {
          var _ = typeof a == "function" ? a.displayName || a.name || "Unknown" : a;
          t && It(ie, _), c && nt(ie, _);
        }
        return Lt(a, t, c, ue, Z, et.current, ie);
      }
    }
    var rt = j.ReactCurrentOwner, gt = j.ReactDebugCurrentFrame;
    function Ne(a) {
      if (a) {
        var P = a._owner, V = me(a.type, a._source, P ? P.type : null);
        gt.setExtraStackFrame(V);
      } else
        gt.setExtraStackFrame(null);
    }
    var at;
    at = !1;
    function ot(a) {
      return typeof a == "object" && a !== null && a.$$typeof === n;
    }
    function bt() {
      {
        if (rt.current) {
          var a = fe(rt.current.type);
          if (a)
            return `

Check the render method of \`` + a + "`.";
        }
        return "";
      }
    }
    function it(a) {
      return "";
    }
    var Ee = {};
    function st(a) {
      {
        var P = bt();
        if (!P) {
          var V = typeof a == "string" ? a : a.displayName || a.name;
          V && (P = `

Check the top-level render call using <` + V + ">.");
        }
        return P;
      }
    }
    function ut(a, P) {
      {
        if (!a._store || a._store.validated || a.key != null)
          return;
        a._store.validated = !0;
        var V = st(P);
        if (Ee[V])
          return;
        Ee[V] = !0;
        var Z = "";
        a && a._owner && a._owner !== rt.current && (Z = " It was passed a child from " + fe(a._owner.type) + "."), Ne(a), te('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', V, Z), Ne(null);
      }
    }
    function De(a, P) {
      {
        if (typeof a != "object")
          return;
        if (Be(a))
          for (var V = 0; V < a.length; V++) {
            var Z = a[V];
            ot(Z) && ut(Z, P);
          }
        else if (ot(a))
          a._store && (a._store.validated = !0);
        else if (a) {
          var ue = Y(a);
          if (typeof ue == "function" && ue !== a.entries)
            for (var de = ue.call(a), ie; !(ie = de.next()).done; )
              ot(ie.value) && ut(ie.value, P);
        }
      }
    }
    function Et(a) {
      {
        var P = a.type;
        if (P == null || typeof P == "string")
          return;
        var V;
        if (typeof P == "function")
          V = P.propTypes;
        else if (typeof P == "object" && (P.$$typeof === g || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        P.$$typeof === C))
          V = P.propTypes;
        else
          return;
        if (V) {
          var Z = fe(P);
          Dt(V, a.props, "prop", Z, a);
        } else if (P.PropTypes !== void 0 && !at) {
          at = !0;
          var ue = fe(P);
          te("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ue || "Unknown");
        }
        typeof P.getDefaultProps == "function" && !P.getDefaultProps.isReactClassApproved && te("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ut(a) {
      {
        for (var P = Object.keys(a.props), V = 0; V < P.length; V++) {
          var Z = P[V];
          if (Z !== "children" && Z !== "key") {
            Ne(a), te("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Z), Ne(null);
            break;
          }
        }
        a.ref !== null && (Ne(a), te("Invalid attribute `ref` supplied to `React.Fragment`."), Ne(null));
      }
    }
    var lt = {};
    function Ot(a, P, V, Z, ue, de) {
      {
        var ie = le(a);
        if (!ie) {
          var t = "";
          (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (t += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var c = it();
          c ? t += c : t += bt();
          var x;
          a === null ? x = "null" : Be(a) ? x = "array" : a !== void 0 && a.$$typeof === n ? (x = "<" + (fe(a.type) || "Unknown") + " />", t = " Did you accidentally export a JSX literal instead of a component?") : x = typeof a, te("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, t);
        }
        var _ = Wt(a, P, V, ue, de);
        if (_ == null)
          return _;
        if (ie) {
          var W = P.children;
          if (W !== void 0)
            if (Z)
              if (Be(W)) {
                for (var se = 0; se < W.length; se++)
                  De(W[se], a);
                Object.freeze && Object.freeze(W);
              } else
                te("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              De(W, a);
        }
        if (he.call(P, "key")) {
          var ne = fe(a), Q = Object.keys(P).filter(function(Oe) {
            return Oe !== "key";
          }), ge = Q.length > 0 ? "{key: someKey, " + Q.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!lt[ne + ge]) {
            var Ce = Q.length > 0 ? "{" + Q.join(": ..., ") + ": ...}" : "{}";
            te(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ge, ne, Ce, ne), lt[ne + ge] = !0;
          }
        }
        return a === o ? Ut(_) : Et(_), _;
      }
    }
    function wt(a, P, V) {
      return Ot(a, P, V, !0);
    }
    function St(a, P, V) {
      return Ot(a, P, V, !1);
    }
    var Ct = St, Vt = wt;
    ft.Fragment = o, ft.jsx = Ct, ft.jsxs = Vt;
  }()), ft;
}
process.env.NODE_ENV === "production" ? Xt.exports = or() : Xt.exports = ir();
var B = Xt.exports, Zt = { exports: {} }, Ye = {}, Qt = { exports: {} }, Tt = { exports: {} }, pe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mn;
function sr() {
  if (mn) return pe;
  mn = 1;
  var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, u = e ? Symbol.for("react.strict_mode") : 60108, f = e ? Symbol.for("react.profiler") : 60114, b = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, g = e ? Symbol.for("react.async_mode") : 60111, O = e ? Symbol.for("react.concurrent_mode") : 60111, v = e ? Symbol.for("react.forward_ref") : 60112, C = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, D = e ? Symbol.for("react.memo") : 60115, L = e ? Symbol.for("react.lazy") : 60116, A = e ? Symbol.for("react.block") : 60121, Y = e ? Symbol.for("react.fundamental") : 60117, j = e ? Symbol.for("react.responder") : 60118, te = e ? Symbol.for("react.scope") : 60119;
  function J(m) {
    if (typeof m == "object" && m !== null) {
      var X = m.$$typeof;
      switch (X) {
        case n:
          switch (m = m.type, m) {
            case g:
            case O:
            case o:
            case f:
            case u:
            case C:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case l:
                case v:
                case L:
                case D:
                case b:
                  return m;
                default:
                  return X;
              }
          }
        case r:
          return X;
      }
    }
  }
  function N(m) {
    return J(m) === O;
  }
  return pe.AsyncMode = g, pe.ConcurrentMode = O, pe.ContextConsumer = l, pe.ContextProvider = b, pe.Element = n, pe.ForwardRef = v, pe.Fragment = o, pe.Lazy = L, pe.Memo = D, pe.Portal = r, pe.Profiler = f, pe.StrictMode = u, pe.Suspense = C, pe.isAsyncMode = function(m) {
    return N(m) || J(m) === g;
  }, pe.isConcurrentMode = N, pe.isContextConsumer = function(m) {
    return J(m) === l;
  }, pe.isContextProvider = function(m) {
    return J(m) === b;
  }, pe.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === n;
  }, pe.isForwardRef = function(m) {
    return J(m) === v;
  }, pe.isFragment = function(m) {
    return J(m) === o;
  }, pe.isLazy = function(m) {
    return J(m) === L;
  }, pe.isMemo = function(m) {
    return J(m) === D;
  }, pe.isPortal = function(m) {
    return J(m) === r;
  }, pe.isProfiler = function(m) {
    return J(m) === f;
  }, pe.isStrictMode = function(m) {
    return J(m) === u;
  }, pe.isSuspense = function(m) {
    return J(m) === C;
  }, pe.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === o || m === O || m === f || m === u || m === C || m === E || typeof m == "object" && m !== null && (m.$$typeof === L || m.$$typeof === D || m.$$typeof === b || m.$$typeof === l || m.$$typeof === v || m.$$typeof === Y || m.$$typeof === j || m.$$typeof === te || m.$$typeof === A);
  }, pe.typeOf = J, pe;
}
var ve = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hn;
function ur() {
  return hn || (hn = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, u = e ? Symbol.for("react.strict_mode") : 60108, f = e ? Symbol.for("react.profiler") : 60114, b = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, g = e ? Symbol.for("react.async_mode") : 60111, O = e ? Symbol.for("react.concurrent_mode") : 60111, v = e ? Symbol.for("react.forward_ref") : 60112, C = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, D = e ? Symbol.for("react.memo") : 60115, L = e ? Symbol.for("react.lazy") : 60116, A = e ? Symbol.for("react.block") : 60121, Y = e ? Symbol.for("react.fundamental") : 60117, j = e ? Symbol.for("react.responder") : 60118, te = e ? Symbol.for("react.scope") : 60119;
    function J(w) {
      return typeof w == "string" || typeof w == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      w === o || w === O || w === f || w === u || w === C || w === E || typeof w == "object" && w !== null && (w.$$typeof === L || w.$$typeof === D || w.$$typeof === b || w.$$typeof === l || w.$$typeof === v || w.$$typeof === Y || w.$$typeof === j || w.$$typeof === te || w.$$typeof === A);
    }
    function N(w) {
      if (typeof w == "object" && w !== null) {
        var ae = w.$$typeof;
        switch (ae) {
          case n:
            var oe = w.type;
            switch (oe) {
              case g:
              case O:
              case o:
              case f:
              case u:
              case C:
                return oe;
              default:
                var me = oe && oe.$$typeof;
                switch (me) {
                  case l:
                  case v:
                  case L:
                  case D:
                  case b:
                    return me;
                  default:
                    return ae;
                }
            }
          case r:
            return ae;
        }
      }
    }
    var m = g, X = O, G = l, q = b, re = n, le = v, ye = o, ce = L, fe = D, z = r, H = f, K = u, y = C, U = !1;
    function $(w) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), i(w) || N(w) === g;
    }
    function i(w) {
      return N(w) === O;
    }
    function h(w) {
      return N(w) === l;
    }
    function d(w) {
      return N(w) === b;
    }
    function S(w) {
      return typeof w == "object" && w !== null && w.$$typeof === n;
    }
    function M(w) {
      return N(w) === v;
    }
    function I(w) {
      return N(w) === o;
    }
    function k(w) {
      return N(w) === L;
    }
    function s(w) {
      return N(w) === D;
    }
    function p(w) {
      return N(w) === r;
    }
    function R(w) {
      return N(w) === f;
    }
    function T(w) {
      return N(w) === u;
    }
    function F(w) {
      return N(w) === C;
    }
    ve.AsyncMode = m, ve.ConcurrentMode = X, ve.ContextConsumer = G, ve.ContextProvider = q, ve.Element = re, ve.ForwardRef = le, ve.Fragment = ye, ve.Lazy = ce, ve.Memo = fe, ve.Portal = z, ve.Profiler = H, ve.StrictMode = K, ve.Suspense = y, ve.isAsyncMode = $, ve.isConcurrentMode = i, ve.isContextConsumer = h, ve.isContextProvider = d, ve.isElement = S, ve.isForwardRef = M, ve.isFragment = I, ve.isLazy = k, ve.isMemo = s, ve.isPortal = p, ve.isProfiler = R, ve.isStrictMode = T, ve.isSuspense = F, ve.isValidElementType = J, ve.typeOf = N;
  }()), ve;
}
var gn;
function In() {
  return gn || (gn = 1, process.env.NODE_ENV === "production" ? Tt.exports = sr() : Tt.exports = ur()), Tt.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var zt, bn;
function lr() {
  if (bn) return zt;
  bn = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function o(f) {
    if (f == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(f);
  }
  function u() {
    try {
      if (!Object.assign)
        return !1;
      var f = new String("abc");
      if (f[5] = "de", Object.getOwnPropertyNames(f)[0] === "5")
        return !1;
      for (var b = {}, l = 0; l < 10; l++)
        b["_" + String.fromCharCode(l)] = l;
      var g = Object.getOwnPropertyNames(b).map(function(v) {
        return b[v];
      });
      if (g.join("") !== "0123456789")
        return !1;
      var O = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(v) {
        O[v] = v;
      }), Object.keys(Object.assign({}, O)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return zt = u() ? Object.assign : function(f, b) {
    for (var l, g = o(f), O, v = 1; v < arguments.length; v++) {
      l = Object(arguments[v]);
      for (var C in l)
        n.call(l, C) && (g[C] = l[C]);
      if (e) {
        O = e(l);
        for (var E = 0; E < O.length; E++)
          r.call(l, O[E]) && (g[O[E]] = l[O[E]]);
      }
    }
    return g;
  }, zt;
}
var Ht, En;
function sn() {
  if (En) return Ht;
  En = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ht = e, Ht;
}
var Yt, On;
function Ln() {
  return On || (On = 1, Yt = Function.call.bind(Object.prototype.hasOwnProperty)), Yt;
}
var qt, wn;
function cr() {
  if (wn) return qt;
  wn = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var n = sn(), r = {}, o = Ln();
    e = function(f) {
      var b = "Warning: " + f;
      typeof console < "u" && console.error(b);
      try {
        throw new Error(b);
      } catch {
      }
    };
  }
  function u(f, b, l, g, O) {
    if (process.env.NODE_ENV !== "production") {
      for (var v in f)
        if (o(f, v)) {
          var C;
          try {
            if (typeof f[v] != "function") {
              var E = Error(
                (g || "React class") + ": " + l + " type `" + v + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof f[v] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw E.name = "Invariant Violation", E;
            }
            C = f[v](b, v, g, l, null, n);
          } catch (L) {
            C = L;
          }
          if (C && !(C instanceof Error) && e(
            (g || "React class") + ": type specification of " + l + " `" + v + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof C + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), C instanceof Error && !(C.message in r)) {
            r[C.message] = !0;
            var D = O ? O() : "";
            e(
              "Failed " + l + " type: " + C.message + (D ?? "")
            );
          }
        }
    }
  }
  return u.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, qt = u, qt;
}
var Bt, Sn;
function fr() {
  if (Sn) return Bt;
  Sn = 1;
  var e = In(), n = lr(), r = sn(), o = Ln(), u = cr(), f = function() {
  };
  process.env.NODE_ENV !== "production" && (f = function(l) {
    var g = "Warning: " + l;
    typeof console < "u" && console.error(g);
    try {
      throw new Error(g);
    } catch {
    }
  });
  function b() {
    return null;
  }
  return Bt = function(l, g) {
    var O = typeof Symbol == "function" && Symbol.iterator, v = "@@iterator";
    function C(i) {
      var h = i && (O && i[O] || i[v]);
      if (typeof h == "function")
        return h;
    }
    var E = "<<anonymous>>", D = {
      array: j("array"),
      bigint: j("bigint"),
      bool: j("boolean"),
      func: j("function"),
      number: j("number"),
      object: j("object"),
      string: j("string"),
      symbol: j("symbol"),
      any: te(),
      arrayOf: J,
      element: N(),
      elementType: m(),
      instanceOf: X,
      node: le(),
      objectOf: q,
      oneOf: G,
      oneOfType: re,
      shape: ce,
      exact: fe
    };
    function L(i, h) {
      return i === h ? i !== 0 || 1 / i === 1 / h : i !== i && h !== h;
    }
    function A(i, h) {
      this.message = i, this.data = h && typeof h == "object" ? h : {}, this.stack = "";
    }
    A.prototype = Error.prototype;
    function Y(i) {
      if (process.env.NODE_ENV !== "production")
        var h = {}, d = 0;
      function S(I, k, s, p, R, T, F) {
        if (p = p || E, T = T || s, F !== r) {
          if (g) {
            var w = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw w.name = "Invariant Violation", w;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ae = p + ":" + s;
            !h[ae] && // Avoid spamming the console because they are often not actionable except for lib authors
            d < 3 && (f(
              "You are manually calling a React.PropTypes validation function for the `" + T + "` prop on `" + p + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), h[ae] = !0, d++);
          }
        }
        return k[s] == null ? I ? k[s] === null ? new A("The " + R + " `" + T + "` is marked as required " + ("in `" + p + "`, but its value is `null`.")) : new A("The " + R + " `" + T + "` is marked as required in " + ("`" + p + "`, but its value is `undefined`.")) : null : i(k, s, p, R, T);
      }
      var M = S.bind(null, !1);
      return M.isRequired = S.bind(null, !0), M;
    }
    function j(i) {
      function h(d, S, M, I, k, s) {
        var p = d[S], R = K(p);
        if (R !== i) {
          var T = y(p);
          return new A(
            "Invalid " + I + " `" + k + "` of type " + ("`" + T + "` supplied to `" + M + "`, expected ") + ("`" + i + "`."),
            { expectedType: i }
          );
        }
        return null;
      }
      return Y(h);
    }
    function te() {
      return Y(b);
    }
    function J(i) {
      function h(d, S, M, I, k) {
        if (typeof i != "function")
          return new A("Property `" + k + "` of component `" + M + "` has invalid PropType notation inside arrayOf.");
        var s = d[S];
        if (!Array.isArray(s)) {
          var p = K(s);
          return new A("Invalid " + I + " `" + k + "` of type " + ("`" + p + "` supplied to `" + M + "`, expected an array."));
        }
        for (var R = 0; R < s.length; R++) {
          var T = i(s, R, M, I, k + "[" + R + "]", r);
          if (T instanceof Error)
            return T;
        }
        return null;
      }
      return Y(h);
    }
    function N() {
      function i(h, d, S, M, I) {
        var k = h[d];
        if (!l(k)) {
          var s = K(k);
          return new A("Invalid " + M + " `" + I + "` of type " + ("`" + s + "` supplied to `" + S + "`, expected a single ReactElement."));
        }
        return null;
      }
      return Y(i);
    }
    function m() {
      function i(h, d, S, M, I) {
        var k = h[d];
        if (!e.isValidElementType(k)) {
          var s = K(k);
          return new A("Invalid " + M + " `" + I + "` of type " + ("`" + s + "` supplied to `" + S + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return Y(i);
    }
    function X(i) {
      function h(d, S, M, I, k) {
        if (!(d[S] instanceof i)) {
          var s = i.name || E, p = $(d[S]);
          return new A("Invalid " + I + " `" + k + "` of type " + ("`" + p + "` supplied to `" + M + "`, expected ") + ("instance of `" + s + "`."));
        }
        return null;
      }
      return Y(h);
    }
    function G(i) {
      if (!Array.isArray(i))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? f(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : f("Invalid argument supplied to oneOf, expected an array.")), b;
      function h(d, S, M, I, k) {
        for (var s = d[S], p = 0; p < i.length; p++)
          if (L(s, i[p]))
            return null;
        var R = JSON.stringify(i, function(F, w) {
          var ae = y(w);
          return ae === "symbol" ? String(w) : w;
        });
        return new A("Invalid " + I + " `" + k + "` of value `" + String(s) + "` " + ("supplied to `" + M + "`, expected one of " + R + "."));
      }
      return Y(h);
    }
    function q(i) {
      function h(d, S, M, I, k) {
        if (typeof i != "function")
          return new A("Property `" + k + "` of component `" + M + "` has invalid PropType notation inside objectOf.");
        var s = d[S], p = K(s);
        if (p !== "object")
          return new A("Invalid " + I + " `" + k + "` of type " + ("`" + p + "` supplied to `" + M + "`, expected an object."));
        for (var R in s)
          if (o(s, R)) {
            var T = i(s, R, M, I, k + "." + R, r);
            if (T instanceof Error)
              return T;
          }
        return null;
      }
      return Y(h);
    }
    function re(i) {
      if (!Array.isArray(i))
        return process.env.NODE_ENV !== "production" && f("Invalid argument supplied to oneOfType, expected an instance of array."), b;
      for (var h = 0; h < i.length; h++) {
        var d = i[h];
        if (typeof d != "function")
          return f(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + U(d) + " at index " + h + "."
          ), b;
      }
      function S(M, I, k, s, p) {
        for (var R = [], T = 0; T < i.length; T++) {
          var F = i[T], w = F(M, I, k, s, p, r);
          if (w == null)
            return null;
          w.data && o(w.data, "expectedType") && R.push(w.data.expectedType);
        }
        var ae = R.length > 0 ? ", expected one of type [" + R.join(", ") + "]" : "";
        return new A("Invalid " + s + " `" + p + "` supplied to " + ("`" + k + "`" + ae + "."));
      }
      return Y(S);
    }
    function le() {
      function i(h, d, S, M, I) {
        return z(h[d]) ? null : new A("Invalid " + M + " `" + I + "` supplied to " + ("`" + S + "`, expected a ReactNode."));
      }
      return Y(i);
    }
    function ye(i, h, d, S, M) {
      return new A(
        (i || "React class") + ": " + h + " type `" + d + "." + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + M + "`."
      );
    }
    function ce(i) {
      function h(d, S, M, I, k) {
        var s = d[S], p = K(s);
        if (p !== "object")
          return new A("Invalid " + I + " `" + k + "` of type `" + p + "` " + ("supplied to `" + M + "`, expected `object`."));
        for (var R in i) {
          var T = i[R];
          if (typeof T != "function")
            return ye(M, I, k, R, y(T));
          var F = T(s, R, M, I, k + "." + R, r);
          if (F)
            return F;
        }
        return null;
      }
      return Y(h);
    }
    function fe(i) {
      function h(d, S, M, I, k) {
        var s = d[S], p = K(s);
        if (p !== "object")
          return new A("Invalid " + I + " `" + k + "` of type `" + p + "` " + ("supplied to `" + M + "`, expected `object`."));
        var R = n({}, d[S], i);
        for (var T in R) {
          var F = i[T];
          if (o(i, T) && typeof F != "function")
            return ye(M, I, k, T, y(F));
          if (!F)
            return new A(
              "Invalid " + I + " `" + k + "` key `" + T + "` supplied to `" + M + "`.\nBad object: " + JSON.stringify(d[S], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(i), null, "  ")
            );
          var w = F(s, T, M, I, k + "." + T, r);
          if (w)
            return w;
        }
        return null;
      }
      return Y(h);
    }
    function z(i) {
      switch (typeof i) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !i;
        case "object":
          if (Array.isArray(i))
            return i.every(z);
          if (i === null || l(i))
            return !0;
          var h = C(i);
          if (h) {
            var d = h.call(i), S;
            if (h !== i.entries) {
              for (; !(S = d.next()).done; )
                if (!z(S.value))
                  return !1;
            } else
              for (; !(S = d.next()).done; ) {
                var M = S.value;
                if (M && !z(M[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function H(i, h) {
      return i === "symbol" ? !0 : h ? h["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && h instanceof Symbol : !1;
    }
    function K(i) {
      var h = typeof i;
      return Array.isArray(i) ? "array" : i instanceof RegExp ? "object" : H(h, i) ? "symbol" : h;
    }
    function y(i) {
      if (typeof i > "u" || i === null)
        return "" + i;
      var h = K(i);
      if (h === "object") {
        if (i instanceof Date)
          return "date";
        if (i instanceof RegExp)
          return "regexp";
      }
      return h;
    }
    function U(i) {
      var h = y(i);
      switch (h) {
        case "array":
        case "object":
          return "an " + h;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + h;
        default:
          return h;
      }
    }
    function $(i) {
      return !i.constructor || !i.constructor.name ? E : i.constructor.name;
    }
    return D.checkPropTypes = u, D.resetWarningCache = u.resetWarningCache, D.PropTypes = D, D;
  }, Bt;
}
var Kt, Cn;
function dr() {
  if (Cn) return Kt;
  Cn = 1;
  var e = sn();
  function n() {
  }
  function r() {
  }
  return r.resetWarningCache = n, Kt = function() {
    function o(b, l, g, O, v, C) {
      if (C !== e) {
        var E = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw E.name = "Invariant Violation", E;
      }
    }
    o.isRequired = o;
    function u() {
      return o;
    }
    var f = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: u,
      element: o,
      elementType: o,
      instanceOf: u,
      node: o,
      objectOf: u,
      oneOf: u,
      oneOfType: u,
      shape: u,
      exact: u,
      checkPropTypes: r,
      resetWarningCache: n
    };
    return f.PropTypes = f, f;
  }, Kt;
}
if (process.env.NODE_ENV !== "production") {
  var pr = In(), vr = !0;
  Qt.exports = fr()(pr.isElement, vr);
} else
  Qt.exports = dr()();
var Wn = Qt.exports, en = { exports: {} }, _e = {}, tn = { exports: {} };
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = v;
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */
  var r = "none", o = "contents", u = /^(input|select|textarea|button|object|iframe)$/;
  function f(C, E) {
    return E.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    C.scrollWidth <= 0 && C.scrollHeight <= 0;
  }
  function b(C) {
    var E = C.offsetWidth <= 0 && C.offsetHeight <= 0;
    if (E && !C.innerHTML) return !0;
    try {
      var D = window.getComputedStyle(C), L = D.getPropertyValue("display");
      return E ? L !== o && f(C, D) : L === r;
    } catch {
      return console.warn("Failed to inspect element style"), !1;
    }
  }
  function l(C) {
    for (var E = C, D = C.getRootNode && C.getRootNode(); E && E !== document.body; ) {
      if (D && E === D && (E = D.host.parentNode), b(E)) return !1;
      E = E.parentNode;
    }
    return !0;
  }
  function g(C, E) {
    var D = C.nodeName.toLowerCase(), L = u.test(D) && !C.disabled || D === "a" && C.href || E;
    return L && l(C);
  }
  function O(C) {
    var E = C.getAttribute("tabindex");
    E === null && (E = void 0);
    var D = isNaN(E);
    return (D || E >= 0) && g(C, !D);
  }
  function v(C) {
    var E = [].slice.call(C.querySelectorAll("*"), 0).reduce(function(D, L) {
      return D.concat(L.shadowRoot ? v(L.shadowRoot) : [L]);
    }, []);
    return E.filter(O);
  }
  e.exports = n.default;
})(tn, tn.exports);
var Un = tn.exports;
Object.defineProperty(_e, "__esModule", {
  value: !0
});
_e.resetState = gr;
_e.log = br;
_e.handleBlur = dt;
_e.handleFocus = pt;
_e.markForFocusLater = Er;
_e.returnFocus = Or;
_e.popWithoutFocus = wr;
_e.setupScopedFocus = Sr;
_e.teardownScopedFocus = Cr;
var yr = Un, mr = hr(yr);
function hr(e) {
  return e && e.__esModule ? e : { default: e };
}
var qe = [], Ge = null, nn = !1;
function gr() {
  qe = [];
}
function br() {
  process.env.NODE_ENV !== "production" && (console.log("focusManager ----------"), qe.forEach(function(e) {
    var n = e || {};
    console.log(n.nodeName, n.className, n.id);
  }), console.log("end focusManager ----------"));
}
function dt() {
  nn = !0;
}
function pt() {
  if (nn) {
    if (nn = !1, !Ge)
      return;
    setTimeout(function() {
      if (!Ge.contains(document.activeElement)) {
        var e = (0, mr.default)(Ge)[0] || Ge;
        e.focus();
      }
    }, 0);
  }
}
function Er() {
  qe.push(document.activeElement);
}
function Or() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, n = null;
  try {
    qe.length !== 0 && (n = qe.pop(), n.focus({ preventScroll: e }));
    return;
  } catch {
    console.warn(["You tried to return focus to", n, "but it is not in the DOM anymore"].join(" "));
  }
}
function wr() {
  qe.length > 0 && qe.pop();
}
function Sr(e) {
  Ge = e, window.addEventListener ? (window.addEventListener("blur", dt, !1), document.addEventListener("focus", pt, !0)) : (window.attachEvent("onBlur", dt), document.attachEvent("onFocus", pt));
}
function Cr() {
  Ge = null, window.addEventListener ? (window.removeEventListener("blur", dt), document.removeEventListener("focus", pt)) : (window.detachEvent("onBlur", dt), document.detachEvent("onFocus", pt));
}
var rn = { exports: {} };
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = b;
  var r = Un, o = u(r);
  function u(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function f() {
    var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    return l.activeElement.shadowRoot ? f(l.activeElement.shadowRoot) : l.activeElement;
  }
  function b(l, g) {
    var O = (0, o.default)(l);
    if (!O.length) {
      g.preventDefault();
      return;
    }
    var v = void 0, C = g.shiftKey, E = O[0], D = O[O.length - 1], L = f();
    if (l === L) {
      if (!C) return;
      v = D;
    }
    if (D === L && !C && (v = E), E === L && C && (v = D), v) {
      g.preventDefault(), v.focus();
      return;
    }
    var A = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent), Y = A != null && A[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    if (Y) {
      var j = O.indexOf(L);
      if (j > -1 && (j += C ? -1 : 1), v = O[j], typeof v > "u") {
        g.preventDefault(), v = C ? D : E, v.focus();
        return;
      }
      g.preventDefault(), v.focus();
    }
  }
  e.exports = n.default;
})(rn, rn.exports);
var Tr = rn.exports, Pe = {}, xr = process.env.NODE_ENV !== "production", Vn = function() {
};
if (xr) {
  var Rr = function(n, r) {
    var o = arguments.length;
    r = new Array(o > 1 ? o - 1 : 0);
    for (var u = 1; u < o; u++)
      r[u - 1] = arguments[u];
    var f = 0, b = "Warning: " + n.replace(/%s/g, function() {
      return r[f++];
    });
    typeof console < "u" && console.error(b);
    try {
      throw new Error(b);
    } catch {
    }
  };
  Vn = function(e, n, r) {
    var o = arguments.length;
    r = new Array(o > 2 ? o - 2 : 0);
    for (var u = 2; u < o; u++)
      r[u - 2] = arguments[u];
    if (n === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    e || Rr.apply(null, [n].concat(r));
  };
}
var _r = Vn, Re = {}, zn = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
(function(e) {
  (function() {
    var n = !!(typeof window < "u" && window.document && window.document.createElement), r = {
      canUseDOM: n,
      canUseWorkers: typeof Worker < "u",
      canUseEventListeners: n && !!(window.addEventListener || window.attachEvent),
      canUseViewport: n && !!window.screen
    };
    e.exports ? e.exports = r : window.ExecutionEnvironment = r;
  })();
})(zn);
var Pr = zn.exports;
Object.defineProperty(Re, "__esModule", {
  value: !0
});
Re.canUseDOM = Re.SafeNodeList = Re.SafeHTMLCollection = void 0;
var Mr = Pr, Ar = jr(Mr);
function jr(e) {
  return e && e.__esModule ? e : { default: e };
}
var jt = Ar.default, Dr = jt.canUseDOM ? window.HTMLElement : {};
Re.SafeHTMLCollection = jt.canUseDOM ? window.HTMLCollection : {};
Re.SafeNodeList = jt.canUseDOM ? window.NodeList : {};
Re.canUseDOM = jt.canUseDOM;
Re.default = Dr;
Object.defineProperty(Pe, "__esModule", {
  value: !0
});
Pe.resetState = Ir;
Pe.log = Lr;
Pe.assertNodeList = Hn;
Pe.setElement = Wr;
Pe.validateElement = un;
Pe.hide = Ur;
Pe.show = Vr;
Pe.documentNotReadyOrSSRTesting = zr;
var kr = _r, Nr = Fr(kr), $r = Re;
function Fr(e) {
  return e && e.__esModule ? e : { default: e };
}
var Se = null;
function Ir() {
  Se && (Se.removeAttribute ? Se.removeAttribute("aria-hidden") : Se.length != null ? Se.forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  }) : document.querySelectorAll(Se).forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  })), Se = null;
}
function Lr() {
  if (process.env.NODE_ENV !== "production") {
    var e = Se || {};
    console.log("ariaAppHider ----------"), console.log(e.nodeName, e.className, e.id), console.log("end ariaAppHider ----------");
  }
}
function Hn(e, n) {
  if (!e || !e.length)
    throw new Error("react-modal: No elements were found for selector " + n + ".");
}
function Wr(e) {
  var n = e;
  if (typeof n == "string" && $r.canUseDOM) {
    var r = document.querySelectorAll(n);
    Hn(r, n), n = r;
  }
  return Se = n || Se, Se;
}
function un(e) {
  var n = e || Se;
  return n ? Array.isArray(n) || n instanceof HTMLCollection || n instanceof NodeList ? n : [n] : ((0, Nr.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
}
function Ur(e) {
  var n = !0, r = !1, o = void 0;
  try {
    for (var u = un(e)[Symbol.iterator](), f; !(n = (f = u.next()).done); n = !0) {
      var b = f.value;
      b.setAttribute("aria-hidden", "true");
    }
  } catch (l) {
    r = !0, o = l;
  } finally {
    try {
      !n && u.return && u.return();
    } finally {
      if (r)
        throw o;
    }
  }
}
function Vr(e) {
  var n = !0, r = !1, o = void 0;
  try {
    for (var u = un(e)[Symbol.iterator](), f; !(n = (f = u.next()).done); n = !0) {
      var b = f.value;
      b.removeAttribute("aria-hidden");
    }
  } catch (l) {
    r = !0, o = l;
  } finally {
    try {
      !n && u.return && u.return();
    } finally {
      if (r)
        throw o;
    }
  }
}
function zr() {
  Se = null;
}
var Xe = {};
Object.defineProperty(Xe, "__esModule", {
  value: !0
});
Xe.resetState = Hr;
Xe.log = Yr;
var Ue = {}, Ve = {};
function Tn(e, n) {
  e.classList.remove(n);
}
function Hr() {
  var e = document.getElementsByTagName("html")[0];
  for (var n in Ue)
    Tn(e, Ue[n]);
  var r = document.body;
  for (var o in Ve)
    Tn(r, Ve[o]);
  Ue = {}, Ve = {};
}
function Yr() {
  if (process.env.NODE_ENV !== "production") {
    var e = document.getElementsByTagName("html")[0].className, n = `Show tracked classes:

`;
    n += "<html /> (" + e + `):
  `;
    for (var r in Ue)
      n += "  " + r + " " + Ue[r] + `
  `;
    e = document.body.className, n += `

doc.body (` + e + `):
  `;
    for (var o in Ve)
      n += "  " + o + " " + Ve[o] + `
  `;
    n += `
`, console.log(n);
  }
}
var qr = function(n, r) {
  return n[r] || (n[r] = 0), n[r] += 1, r;
}, Br = function(n, r) {
  return n[r] && (n[r] -= 1), r;
}, Kr = function(n, r, o) {
  o.forEach(function(u) {
    qr(r, u), n.add(u);
  });
}, Jr = function(n, r, o) {
  o.forEach(function(u) {
    Br(r, u), r[u] === 0 && n.remove(u);
  });
};
Xe.add = function(n, r) {
  return Kr(n.classList, n.nodeName.toLowerCase() == "html" ? Ue : Ve, r.split(" "));
};
Xe.remove = function(n, r) {
  return Jr(n.classList, n.nodeName.toLowerCase() == "html" ? Ue : Ve, r.split(" "));
};
var Ze = {};
Object.defineProperty(Ze, "__esModule", {
  value: !0
});
Ze.log = Xr;
Ze.resetState = Zr;
function Gr(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
var Yn = function e() {
  var n = this;
  Gr(this, e), this.register = function(r) {
    if (n.openInstances.indexOf(r) !== -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Cannot register modal instance that's already open");
      return;
    }
    n.openInstances.push(r), n.emit("register");
  }, this.deregister = function(r) {
    var o = n.openInstances.indexOf(r);
    if (o === -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Unable to deregister " + r + " as it was never registered");
      return;
    }
    n.openInstances.splice(o, 1), n.emit("deregister");
  }, this.subscribe = function(r) {
    n.subscribers.push(r);
  }, this.emit = function(r) {
    n.subscribers.forEach(function(o) {
      return o(
        r,
        // shallow copy to avoid accidental mutation
        n.openInstances.slice()
      );
    });
  }, this.openInstances = [], this.subscribers = [];
}, _t = new Yn();
function Xr() {
  console.log("portalOpenInstances ----------"), console.log(_t.openInstances.length), _t.openInstances.forEach(function(e) {
    return console.log(e);
  }), console.log("end portalOpenInstances ----------");
}
function Zr() {
  _t = new Yn();
}
Ze.default = _t;
var ln = {};
Object.defineProperty(ln, "__esModule", {
  value: !0
});
ln.resetState = na;
ln.log = ra;
var Qr = Ze, ea = ta(Qr);
function ta(e) {
  return e && e.__esModule ? e : { default: e };
}
var be = void 0, Te = void 0, ze = [];
function na() {
  for (var e = [be, Te], n = 0; n < e.length; n++) {
    var r = e[n];
    r && r.parentNode && r.parentNode.removeChild(r);
  }
  be = Te = null, ze = [];
}
function ra() {
  console.log("bodyTrap ----------"), console.log(ze.length);
  for (var e = [be, Te], n = 0; n < e.length; n++) {
    var r = e[n], o = r || {};
    console.log(o.nodeName, o.className, o.id);
  }
  console.log("edn bodyTrap ----------");
}
function xn() {
  if (ze.length === 0) {
    process.env.NODE_ENV !== "production" && console.warn("React-Modal: Open instances > 0 expected");
    return;
  }
  ze[ze.length - 1].focusContent();
}
function aa(e, n) {
  !be && !Te && (be = document.createElement("div"), be.setAttribute("data-react-modal-body-trap", ""), be.style.position = "absolute", be.style.opacity = "0", be.setAttribute("tabindex", "0"), be.addEventListener("focus", xn), Te = be.cloneNode(), Te.addEventListener("focus", xn)), ze = n, ze.length > 0 ? (document.body.firstChild !== be && document.body.insertBefore(be, document.body.firstChild), document.body.lastChild !== Te && document.body.appendChild(Te)) : (be.parentElement && be.parentElement.removeChild(be), Te.parentElement && Te.parentElement.removeChild(Te));
}
ea.default.subscribe(aa);
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  });
  var r = Object.assign || function(z) {
    for (var H = 1; H < arguments.length; H++) {
      var K = arguments[H];
      for (var y in K)
        Object.prototype.hasOwnProperty.call(K, y) && (z[y] = K[y]);
    }
    return z;
  }, o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(z) {
    return typeof z;
  } : function(z) {
    return z && typeof Symbol == "function" && z.constructor === Symbol && z !== Symbol.prototype ? "symbol" : typeof z;
  }, u = /* @__PURE__ */ function() {
    function z(H, K) {
      for (var y = 0; y < K.length; y++) {
        var U = K[y];
        U.enumerable = U.enumerable || !1, U.configurable = !0, "value" in U && (U.writable = !0), Object.defineProperty(H, U.key, U);
      }
    }
    return function(H, K, y) {
      return K && z(H.prototype, K), y && z(H, y), H;
    };
  }(), f = At, b = Wn, l = m(b), g = _e, O = N(g), v = Tr, C = m(v), E = Pe, D = N(E), L = Xe, A = N(L), Y = Re, j = m(Y), te = Ze, J = m(te);
  function N(z) {
    if (z && z.__esModule)
      return z;
    var H = {};
    if (z != null)
      for (var K in z)
        Object.prototype.hasOwnProperty.call(z, K) && (H[K] = z[K]);
    return H.default = z, H;
  }
  function m(z) {
    return z && z.__esModule ? z : { default: z };
  }
  function X(z, H) {
    if (!(z instanceof H))
      throw new TypeError("Cannot call a class as a function");
  }
  function G(z, H) {
    if (!z)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return H && (typeof H == "object" || typeof H == "function") ? H : z;
  }
  function q(z, H) {
    if (typeof H != "function" && H !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof H);
    z.prototype = Object.create(H && H.prototype, { constructor: { value: z, enumerable: !1, writable: !0, configurable: !0 } }), H && (Object.setPrototypeOf ? Object.setPrototypeOf(z, H) : z.__proto__ = H);
  }
  var re = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  }, le = function(H) {
    return H.code === "Tab" || H.keyCode === 9;
  }, ye = function(H) {
    return H.code === "Escape" || H.keyCode === 27;
  }, ce = 0, fe = function(z) {
    q(H, z);
    function H(K) {
      X(this, H);
      var y = G(this, (H.__proto__ || Object.getPrototypeOf(H)).call(this, K));
      return y.setOverlayRef = function(U) {
        y.overlay = U, y.props.overlayRef && y.props.overlayRef(U);
      }, y.setContentRef = function(U) {
        y.content = U, y.props.contentRef && y.props.contentRef(U);
      }, y.afterClose = function() {
        var U = y.props, $ = U.appElement, i = U.ariaHideApp, h = U.htmlOpenClassName, d = U.bodyOpenClassName, S = U.parentSelector, M = S && S().ownerDocument || document;
        d && A.remove(M.body, d), h && A.remove(M.getElementsByTagName("html")[0], h), i && ce > 0 && (ce -= 1, ce === 0 && D.show($)), y.props.shouldFocusAfterRender && (y.props.shouldReturnFocusAfterClose ? (O.returnFocus(y.props.preventScroll), O.teardownScopedFocus()) : O.popWithoutFocus()), y.props.onAfterClose && y.props.onAfterClose(), J.default.deregister(y);
      }, y.open = function() {
        y.beforeOpen(), y.state.afterOpen && y.state.beforeClose ? (clearTimeout(y.closeTimer), y.setState({ beforeClose: !1 })) : (y.props.shouldFocusAfterRender && (O.setupScopedFocus(y.node), O.markForFocusLater()), y.setState({ isOpen: !0 }, function() {
          y.openAnimationFrame = requestAnimationFrame(function() {
            y.setState({ afterOpen: !0 }), y.props.isOpen && y.props.onAfterOpen && y.props.onAfterOpen({
              overlayEl: y.overlay,
              contentEl: y.content
            });
          });
        }));
      }, y.close = function() {
        y.props.closeTimeoutMS > 0 ? y.closeWithTimeout() : y.closeWithoutTimeout();
      }, y.focusContent = function() {
        return y.content && !y.contentHasFocus() && y.content.focus({ preventScroll: !0 });
      }, y.closeWithTimeout = function() {
        var U = Date.now() + y.props.closeTimeoutMS;
        y.setState({ beforeClose: !0, closesAt: U }, function() {
          y.closeTimer = setTimeout(y.closeWithoutTimeout, y.state.closesAt - Date.now());
        });
      }, y.closeWithoutTimeout = function() {
        y.setState({
          beforeClose: !1,
          isOpen: !1,
          afterOpen: !1,
          closesAt: null
        }, y.afterClose);
      }, y.handleKeyDown = function(U) {
        le(U) && (0, C.default)(y.content, U), y.props.shouldCloseOnEsc && ye(U) && (U.stopPropagation(), y.requestClose(U));
      }, y.handleOverlayOnClick = function(U) {
        y.shouldClose === null && (y.shouldClose = !0), y.shouldClose && y.props.shouldCloseOnOverlayClick && (y.ownerHandlesClose() ? y.requestClose(U) : y.focusContent()), y.shouldClose = null;
      }, y.handleContentOnMouseUp = function() {
        y.shouldClose = !1;
      }, y.handleOverlayOnMouseDown = function(U) {
        !y.props.shouldCloseOnOverlayClick && U.target == y.overlay && U.preventDefault();
      }, y.handleContentOnClick = function() {
        y.shouldClose = !1;
      }, y.handleContentOnMouseDown = function() {
        y.shouldClose = !1;
      }, y.requestClose = function(U) {
        return y.ownerHandlesClose() && y.props.onRequestClose(U);
      }, y.ownerHandlesClose = function() {
        return y.props.onRequestClose;
      }, y.shouldBeClosed = function() {
        return !y.state.isOpen && !y.state.beforeClose;
      }, y.contentHasFocus = function() {
        return document.activeElement === y.content || y.content.contains(document.activeElement);
      }, y.buildClassName = function(U, $) {
        var i = (typeof $ > "u" ? "undefined" : o($)) === "object" ? $ : {
          base: re[U],
          afterOpen: re[U] + "--after-open",
          beforeClose: re[U] + "--before-close"
        }, h = i.base;
        return y.state.afterOpen && (h = h + " " + i.afterOpen), y.state.beforeClose && (h = h + " " + i.beforeClose), typeof $ == "string" && $ ? h + " " + $ : h;
      }, y.attributesFromObject = function(U, $) {
        return Object.keys($).reduce(function(i, h) {
          return i[U + "-" + h] = $[h], i;
        }, {});
      }, y.state = {
        afterOpen: !1,
        beforeClose: !1
      }, y.shouldClose = null, y.moveFromContentToOverlay = null, y;
    }
    return u(H, [{
      key: "componentDidMount",
      value: function() {
        this.props.isOpen && this.open();
      }
    }, {
      key: "componentDidUpdate",
      value: function(y, U) {
        process.env.NODE_ENV !== "production" && (y.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), y.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !y.isOpen ? this.open() : !this.props.isOpen && y.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !U.isOpen && this.focusContent();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
      }
    }, {
      key: "beforeOpen",
      value: function() {
        var y = this.props, U = y.appElement, $ = y.ariaHideApp, i = y.htmlOpenClassName, h = y.bodyOpenClassName, d = y.parentSelector, S = d && d().ownerDocument || document;
        h && A.add(S.body, h), i && A.add(S.getElementsByTagName("html")[0], i), $ && (ce += 1, D.hide(U)), J.default.register(this);
      }
      // Don't steal focus from inner elements
    }, {
      key: "render",
      value: function() {
        var y = this.props, U = y.id, $ = y.className, i = y.overlayClassName, h = y.defaultStyles, d = y.children, S = $ ? {} : h.content, M = i ? {} : h.overlay;
        if (this.shouldBeClosed())
          return null;
        var I = {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", i),
          style: r({}, M, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        }, k = r({
          id: U,
          ref: this.setContentRef,
          style: r({}, S, this.props.style.content),
          className: this.buildClassName("content", $),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", r({ modal: !0 }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        }), s = this.props.contentElement(k, d);
        return this.props.overlayElement(I, s);
      }
    }]), H;
  }(f.Component);
  fe.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  }, fe.propTypes = {
    isOpen: l.default.bool.isRequired,
    defaultStyles: l.default.shape({
      content: l.default.object,
      overlay: l.default.object
    }),
    style: l.default.shape({
      content: l.default.object,
      overlay: l.default.object
    }),
    className: l.default.oneOfType([l.default.string, l.default.object]),
    overlayClassName: l.default.oneOfType([l.default.string, l.default.object]),
    parentSelector: l.default.func,
    bodyOpenClassName: l.default.string,
    htmlOpenClassName: l.default.string,
    ariaHideApp: l.default.bool,
    appElement: l.default.oneOfType([l.default.instanceOf(j.default), l.default.instanceOf(Y.SafeHTMLCollection), l.default.instanceOf(Y.SafeNodeList), l.default.arrayOf(l.default.instanceOf(j.default))]),
    onAfterOpen: l.default.func,
    onAfterClose: l.default.func,
    onRequestClose: l.default.func,
    closeTimeoutMS: l.default.number,
    shouldFocusAfterRender: l.default.bool,
    shouldCloseOnOverlayClick: l.default.bool,
    shouldReturnFocusAfterClose: l.default.bool,
    preventScroll: l.default.bool,
    role: l.default.string,
    contentLabel: l.default.string,
    aria: l.default.object,
    data: l.default.object,
    children: l.default.node,
    shouldCloseOnEsc: l.default.bool,
    overlayRef: l.default.func,
    contentRef: l.default.func,
    id: l.default.string,
    overlayElement: l.default.func,
    contentElement: l.default.func,
    testId: l.default.string
  }, n.default = fe, e.exports = n.default;
})(en, en.exports);
var oa = en.exports;
function qn() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  e != null && this.setState(e);
}
function Bn(e) {
  function n(r) {
    var o = this.constructor.getDerivedStateFromProps(e, r);
    return o ?? null;
  }
  this.setState(n.bind(this));
}
function Kn(e, n) {
  try {
    var r = this.props, o = this.state;
    this.props = e, this.state = n, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      r,
      o
    );
  } finally {
    this.props = r, this.state = o;
  }
}
qn.__suppressDeprecationWarning = !0;
Bn.__suppressDeprecationWarning = !0;
Kn.__suppressDeprecationWarning = !0;
function ia(e) {
  var n = e.prototype;
  if (!n || !n.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof e.getDerivedStateFromProps != "function" && typeof n.getSnapshotBeforeUpdate != "function")
    return e;
  var r = null, o = null, u = null;
  if (typeof n.componentWillMount == "function" ? r = "componentWillMount" : typeof n.UNSAFE_componentWillMount == "function" && (r = "UNSAFE_componentWillMount"), typeof n.componentWillReceiveProps == "function" ? o = "componentWillReceiveProps" : typeof n.UNSAFE_componentWillReceiveProps == "function" && (o = "UNSAFE_componentWillReceiveProps"), typeof n.componentWillUpdate == "function" ? u = "componentWillUpdate" : typeof n.UNSAFE_componentWillUpdate == "function" && (u = "UNSAFE_componentWillUpdate"), r !== null || o !== null || u !== null) {
    var f = e.displayName || e.name, b = typeof e.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + f + " uses " + b + " but also contains the following legacy lifecycles:" + (r !== null ? `
  ` + r : "") + (o !== null ? `
  ` + o : "") + (u !== null ? `
  ` + u : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof e.getDerivedStateFromProps == "function" && (n.componentWillMount = qn, n.componentWillReceiveProps = Bn), typeof n.getSnapshotBeforeUpdate == "function") {
    if (typeof n.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    n.componentWillUpdate = Kn;
    var l = n.componentDidUpdate;
    n.componentDidUpdate = function(O, v, C) {
      var E = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : C;
      l.call(this, O, v, E);
    };
  }
  return e;
}
const sa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill: ia
}, Symbol.toStringTag, { value: "Module" })), ua = /* @__PURE__ */ ar(sa);
Object.defineProperty(Ye, "__esModule", {
  value: !0
});
Ye.bodyOpenClassName = Ye.portalClassName = void 0;
var Rn = Object.assign || function(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n];
    for (var o in r)
      Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
  }
  return e;
}, la = /* @__PURE__ */ function() {
  function e(n, r) {
    for (var o = 0; o < r.length; o++) {
      var u = r[o];
      u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(n, u.key, u);
    }
  }
  return function(n, r, o) {
    return r && e(n.prototype, r), o && e(n, o), n;
  };
}(), Jn = At, Pt = vt(Jn), ca = tr, Mt = vt(ca), fa = Wn, ee = vt(fa), da = oa, _n = vt(da), pa = Pe, va = ma(pa), $e = Re, Pn = vt($e), ya = ua;
function ma(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
  return n.default = e, n;
}
function vt(e) {
  return e && e.__esModule ? e : { default: e };
}
function ha(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Mn(e, n) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n && (typeof n == "object" || typeof n == "function") ? n : e;
}
function ga(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof n);
  e.prototype = Object.create(n && n.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
}
var ba = Ye.portalClassName = "ReactModalPortal", Ea = Ye.bodyOpenClassName = "ReactModal__Body--open", We = $e.canUseDOM && Mt.default.createPortal !== void 0, an = function(n) {
  return document.createElement(n);
}, An = function() {
  return We ? Mt.default.createPortal : Mt.default.unstable_renderSubtreeIntoContainer;
};
function xt(e) {
  return e();
}
var Qe = function(e) {
  ga(n, e);
  function n() {
    var r, o, u, f;
    ha(this, n);
    for (var b = arguments.length, l = Array(b), g = 0; g < b; g++)
      l[g] = arguments[g];
    return f = (o = (u = Mn(this, (r = n.__proto__ || Object.getPrototypeOf(n)).call.apply(r, [this].concat(l))), u), u.removePortal = function() {
      !We && Mt.default.unmountComponentAtNode(u.node);
      var O = xt(u.props.parentSelector);
      O && O.contains(u.node) ? O.removeChild(u.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
    }, u.portalRef = function(O) {
      u.portal = O;
    }, u.renderPortal = function(O) {
      var v = An(), C = v(u, Pt.default.createElement(_n.default, Rn({ defaultStyles: n.defaultStyles }, O)), u.node);
      u.portalRef(C);
    }, o), Mn(u, f);
  }
  return la(n, [{
    key: "componentDidMount",
    value: function() {
      if ($e.canUseDOM) {
        We || (this.node = an("div")), this.node.className = this.props.portalClassName;
        var o = xt(this.props.parentSelector);
        o.appendChild(this.node), !We && this.renderPortal(this.props);
      }
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function(o) {
      var u = xt(o.parentSelector), f = xt(this.props.parentSelector);
      return { prevParent: u, nextParent: f };
    }
  }, {
    key: "componentDidUpdate",
    value: function(o, u, f) {
      if ($e.canUseDOM) {
        var b = this.props, l = b.isOpen, g = b.portalClassName;
        o.portalClassName !== g && (this.node.className = g);
        var O = f.prevParent, v = f.nextParent;
        v !== O && (O.removeChild(this.node), v.appendChild(this.node)), !(!o.isOpen && !l) && !We && this.renderPortal(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      if (!(!$e.canUseDOM || !this.node || !this.portal)) {
        var o = this.portal.state, u = Date.now(), f = o.isOpen && this.props.closeTimeoutMS && (o.closesAt || u + this.props.closeTimeoutMS);
        f ? (o.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, f - u)) : this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function() {
      if (!$e.canUseDOM || !We)
        return null;
      !this.node && We && (this.node = an("div"));
      var o = An();
      return o(Pt.default.createElement(_n.default, Rn({
        ref: this.portalRef,
        defaultStyles: n.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function(o) {
      va.setElement(o);
    }
    /* eslint-disable react/no-unused-prop-types */
    /* eslint-enable react/no-unused-prop-types */
  }]), n;
}(Jn.Component);
Qe.propTypes = {
  isOpen: ee.default.bool.isRequired,
  style: ee.default.shape({
    content: ee.default.object,
    overlay: ee.default.object
  }),
  portalClassName: ee.default.string,
  bodyOpenClassName: ee.default.string,
  htmlOpenClassName: ee.default.string,
  className: ee.default.oneOfType([ee.default.string, ee.default.shape({
    base: ee.default.string.isRequired,
    afterOpen: ee.default.string.isRequired,
    beforeClose: ee.default.string.isRequired
  })]),
  overlayClassName: ee.default.oneOfType([ee.default.string, ee.default.shape({
    base: ee.default.string.isRequired,
    afterOpen: ee.default.string.isRequired,
    beforeClose: ee.default.string.isRequired
  })]),
  appElement: ee.default.oneOfType([ee.default.instanceOf(Pn.default), ee.default.instanceOf($e.SafeHTMLCollection), ee.default.instanceOf($e.SafeNodeList), ee.default.arrayOf(ee.default.instanceOf(Pn.default))]),
  onAfterOpen: ee.default.func,
  onRequestClose: ee.default.func,
  closeTimeoutMS: ee.default.number,
  ariaHideApp: ee.default.bool,
  shouldFocusAfterRender: ee.default.bool,
  shouldCloseOnOverlayClick: ee.default.bool,
  shouldReturnFocusAfterClose: ee.default.bool,
  preventScroll: ee.default.bool,
  parentSelector: ee.default.func,
  aria: ee.default.object,
  data: ee.default.object,
  role: ee.default.string,
  contentLabel: ee.default.string,
  shouldCloseOnEsc: ee.default.bool,
  overlayRef: ee.default.func,
  contentRef: ee.default.func,
  id: ee.default.string,
  overlayElement: ee.default.func,
  contentElement: ee.default.func
};
Qe.defaultProps = {
  isOpen: !1,
  portalClassName: ba,
  bodyOpenClassName: Ea,
  role: "dialog",
  ariaHideApp: !0,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: !0,
  shouldCloseOnEsc: !0,
  shouldCloseOnOverlayClick: !0,
  shouldReturnFocusAfterClose: !0,
  preventScroll: !1,
  parentSelector: function() {
    return document.body;
  },
  overlayElement: function(n, r) {
    return Pt.default.createElement(
      "div",
      n,
      r
    );
  },
  contentElement: function(n, r) {
    return Pt.default.createElement(
      "div",
      n,
      r
    );
  }
};
Qe.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
(0, ya.polyfill)(Qe);
process.env.NODE_ENV !== "production" && (Qe.setCreateHTMLElement = function(e) {
  return an = e;
});
Ye.default = Qe;
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  });
  var r = Ye, o = u(r);
  function u(f) {
    return f && f.__esModule ? f : { default: f };
  }
  n.default = o.default, e.exports = n.default;
})(Zt, Zt.exports);
var Oa = Zt.exports;
const jn = /* @__PURE__ */ Fn(Oa);
var Gn = { exports: {} };
(function(e, n) {
  (function(o, u) {
    e.exports = u();
  })(typeof self < "u" ? self : rr, function() {
    return (
      /******/
      function(r) {
        var o = {};
        function u(f) {
          if (o[f])
            return o[f].exports;
          var b = o[f] = {
            /******/
            i: f,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return r[f].call(b.exports, b, b.exports, u), b.l = !0, b.exports;
        }
        return u.m = r, u.c = o, u.d = function(f, b, l) {
          u.o(f, b) || Object.defineProperty(f, b, {
            /******/
            configurable: !1,
            /******/
            enumerable: !0,
            /******/
            get: l
            /******/
          });
        }, u.n = function(f) {
          var b = f && f.__esModule ? (
            /******/
            function() {
              return f.default;
            }
          ) : (
            /******/
            function() {
              return f;
            }
          );
          return u.d(b, "a", b), b;
        }, u.o = function(f, b) {
          return Object.prototype.hasOwnProperty.call(f, b);
        }, u.p = "/", u(u.s = 7);
      }([
        /* 0 */
        /***/
        function(r, o, u) {
          var f = function(g) {
          };
          process.env.NODE_ENV !== "production" && (f = function(g) {
            if (g === void 0)
              throw new Error("invariant requires an error message argument");
          });
          function b(l, g, O, v, C, E, D, L) {
            if (f(g), !l) {
              var A;
              if (g === void 0)
                A = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
              else {
                var Y = [O, v, C, E, D, L], j = 0;
                A = new Error(g.replace(/%s/g, function() {
                  return Y[j++];
                })), A.name = "Invariant Violation";
              }
              throw A.framesToPop = 1, A;
            }
          }
          r.exports = b;
        },
        /* 1 */
        /***/
        function(r, o, u) {
          function f(l) {
            return function() {
              return l;
            };
          }
          var b = function() {
          };
          b.thatReturns = f, b.thatReturnsFalse = f(!1), b.thatReturnsTrue = f(!0), b.thatReturnsNull = f(null), b.thatReturnsThis = function() {
            return this;
          }, b.thatReturnsArgument = function(l) {
            return l;
          }, r.exports = b;
        },
        /* 2 */
        /***/
        function(r, o, u) {
          /*
          object-assign
          (c) Sindre Sorhus
          @license MIT
          */
          var f = Object.getOwnPropertySymbols, b = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
          function g(v) {
            if (v == null)
              throw new TypeError("Object.assign cannot be called with null or undefined");
            return Object(v);
          }
          function O() {
            try {
              if (!Object.assign)
                return !1;
              var v = new String("abc");
              if (v[5] = "de", Object.getOwnPropertyNames(v)[0] === "5")
                return !1;
              for (var C = {}, E = 0; E < 10; E++)
                C["_" + String.fromCharCode(E)] = E;
              var D = Object.getOwnPropertyNames(C).map(function(A) {
                return C[A];
              });
              if (D.join("") !== "0123456789")
                return !1;
              var L = {};
              return "abcdefghijklmnopqrst".split("").forEach(function(A) {
                L[A] = A;
              }), Object.keys(Object.assign({}, L)).join("") === "abcdefghijklmnopqrst";
            } catch {
              return !1;
            }
          }
          r.exports = O() ? Object.assign : function(v, C) {
            for (var E, D = g(v), L, A = 1; A < arguments.length; A++) {
              E = Object(arguments[A]);
              for (var Y in E)
                b.call(E, Y) && (D[Y] = E[Y]);
              if (f) {
                L = f(E);
                for (var j = 0; j < L.length; j++)
                  l.call(E, L[j]) && (D[L[j]] = E[L[j]]);
              }
            }
            return D;
          };
        },
        /* 3 */
        /***/
        function(r, o, u) {
          var f = u(1), b = f;
          if (process.env.NODE_ENV !== "production") {
            var l = function(O) {
              for (var v = arguments.length, C = Array(v > 1 ? v - 1 : 0), E = 1; E < v; E++)
                C[E - 1] = arguments[E];
              var D = 0, L = "Warning: " + O.replace(/%s/g, function() {
                return C[D++];
              });
              typeof console < "u" && console.error(L);
              try {
                throw new Error(L);
              } catch {
              }
            };
            b = function(O, v) {
              if (v === void 0)
                throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
              if (v.indexOf("Failed Composite propType: ") !== 0 && !O) {
                for (var C = arguments.length, E = Array(C > 2 ? C - 2 : 0), D = 2; D < C; D++)
                  E[D - 2] = arguments[D];
                l.apply(void 0, [v].concat(E));
              }
            };
          }
          r.exports = b;
        },
        /* 4 */
        /***/
        function(r, o, u) {
          var f = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
          r.exports = f;
        },
        /* 5 */
        /***/
        function(r, o, u) {
          var f = {};
          process.env.NODE_ENV !== "production" && Object.freeze(f), r.exports = f;
        },
        /* 6 */
        /***/
        function(r, o, u) {
          if (process.env.NODE_ENV !== "production")
            var f = u(0), b = u(3), l = u(4), g = {};
          function O(v, C, E, D, L) {
            if (process.env.NODE_ENV !== "production") {
              for (var A in v)
                if (v.hasOwnProperty(A)) {
                  var Y;
                  try {
                    f(typeof v[A] == "function", "%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.", D || "React class", E, A, typeof v[A]), Y = v[A](C, A, D, E, null, l);
                  } catch (te) {
                    Y = te;
                  }
                  if (b(!Y || Y instanceof Error, "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", D || "React class", E, A, typeof Y), Y instanceof Error && !(Y.message in g)) {
                    g[Y.message] = !0;
                    var j = L ? L() : "";
                    b(!1, "Failed %s type: %s%s", E, Y.message, j ?? "");
                  }
                }
            }
          }
          r.exports = O;
        },
        /* 7 */
        /***/
        function(r, o, u) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var f = Object.assign || function(N) {
            for (var m = 1; m < arguments.length; m++) {
              var X = arguments[m];
              for (var G in X)
                Object.prototype.hasOwnProperty.call(X, G) && (N[G] = X[G]);
            }
            return N;
          }, b = /* @__PURE__ */ function() {
            function N(m, X) {
              for (var G = 0; G < X.length; G++) {
                var q = X[G];
                q.enumerable = q.enumerable || !1, q.configurable = !0, "value" in q && (q.writable = !0), Object.defineProperty(m, q.key, q);
              }
            }
            return function(m, X, G) {
              return X && N(m.prototype, X), G && N(m, G), m;
            };
          }(), l = u(8), g = L(l), O = u(11), v = L(O), C = u(14), E = D(C);
          function D(N) {
            if (N && N.__esModule)
              return N;
            var m = {};
            if (N != null)
              for (var X in N)
                Object.prototype.hasOwnProperty.call(N, X) && (m[X] = N[X]);
            return m.default = N, m;
          }
          function L(N) {
            return N && N.__esModule ? N : { default: N };
          }
          function A(N, m) {
            var X = {};
            for (var G in N)
              m.indexOf(G) >= 0 || Object.prototype.hasOwnProperty.call(N, G) && (X[G] = N[G]);
            return X;
          }
          function Y(N, m) {
            if (!(N instanceof m))
              throw new TypeError("Cannot call a class as a function");
          }
          function j(N, m) {
            if (!N)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return m && (typeof m == "object" || typeof m == "function") ? m : N;
          }
          function te(N, m) {
            if (typeof m != "function" && m !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof m);
            N.prototype = Object.create(m && m.prototype, { constructor: { value: N, enumerable: !1, writable: !0, configurable: !0 } }), m && (Object.setPrototypeOf ? Object.setPrototypeOf(N, m) : N.__proto__ = m);
          }
          var J = function(N) {
            te(m, N);
            function m() {
              var X, G, q, re;
              Y(this, m);
              for (var le = arguments.length, ye = Array(le), ce = 0; ce < le; ce++)
                ye[ce] = arguments[ce];
              return re = (G = (q = j(this, (X = m.__proto__ || Object.getPrototypeOf(m)).call.apply(X, [this].concat(ye))), q), q.state = {
                delayed: q.props.delay > 0
              }, G), j(q, re);
            }
            return b(m, [{
              key: "componentDidMount",
              value: function() {
                var G = this, q = this.props.delay, re = this.state.delayed;
                re && (this.timeout = setTimeout(function() {
                  G.setState({
                    delayed: !1
                  });
                }, q));
              }
            }, {
              key: "componentWillUnmount",
              value: function() {
                var G = this.timeout;
                G && clearTimeout(G);
              }
            }, {
              key: "render",
              value: function() {
                var G = this.props, q = G.color;
                G.delay;
                var re = G.type, le = G.height, ye = G.width, ce = A(G, ["color", "delay", "type", "height", "width"]), fe = this.state.delayed ? "blank" : re, z = E[fe], H = {
                  fill: q,
                  height: le,
                  width: ye
                };
                return g.default.createElement("div", f({
                  style: H,
                  dangerouslySetInnerHTML: { __html: z }
                }, ce));
              }
            }]), m;
          }(l.Component);
          J.propTypes = {
            color: v.default.string,
            delay: v.default.number,
            type: v.default.string,
            height: v.default.oneOfType([v.default.string, v.default.number]),
            width: v.default.oneOfType([v.default.string, v.default.number])
          }, J.defaultProps = {
            color: "#fff",
            delay: 0,
            type: "balls",
            height: 64,
            width: 64
          }, o.default = J;
        },
        /* 8 */
        /***/
        function(r, o, u) {
          process.env.NODE_ENV === "production" ? r.exports = u(9) : r.exports = u(10);
        },
        /* 9 */
        /***/
        function(r, o, u) {
          /** @license React v16.3.2
           * react.production.min.js
           *
           * Copyright (c) 2013-present, Facebook, Inc.
           *
           * This source code is licensed under the MIT license found in the
           * LICENSE file in the root directory of this source tree.
           */
          var f = u(2), b = u(0), l = u(5), g = u(1), O = typeof Symbol == "function" && Symbol.for, v = O ? Symbol.for("react.element") : 60103, C = O ? Symbol.for("react.portal") : 60106, E = O ? Symbol.for("react.fragment") : 60107, D = O ? Symbol.for("react.strict_mode") : 60108, L = O ? Symbol.for("react.provider") : 60109, A = O ? Symbol.for("react.context") : 60110, Y = O ? Symbol.for("react.async_mode") : 60111, j = O ? Symbol.for("react.forward_ref") : 60112, te = typeof Symbol == "function" && Symbol.iterator;
          function J(s) {
            for (var p = arguments.length - 1, R = "http://reactjs.org/docs/error-decoder.html?invariant=" + s, T = 0; T < p; T++) R += "&args[]=" + encodeURIComponent(arguments[T + 1]);
            b(!1, "Minified React error #" + s + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", R);
          }
          var N = { isMounted: function() {
            return !1;
          }, enqueueForceUpdate: function() {
          }, enqueueReplaceState: function() {
          }, enqueueSetState: function() {
          } };
          function m(s, p, R) {
            this.props = s, this.context = p, this.refs = l, this.updater = R || N;
          }
          m.prototype.isReactComponent = {}, m.prototype.setState = function(s, p) {
            typeof s != "object" && typeof s != "function" && s != null && J("85"), this.updater.enqueueSetState(this, s, p, "setState");
          }, m.prototype.forceUpdate = function(s) {
            this.updater.enqueueForceUpdate(this, s, "forceUpdate");
          };
          function X() {
          }
          X.prototype = m.prototype;
          function G(s, p, R) {
            this.props = s, this.context = p, this.refs = l, this.updater = R || N;
          }
          var q = G.prototype = new X();
          q.constructor = G, f(q, m.prototype), q.isPureReactComponent = !0;
          var re = { current: null }, le = Object.prototype.hasOwnProperty, ye = { key: !0, ref: !0, __self: !0, __source: !0 };
          function ce(s, p, R) {
            var T = void 0, F = {}, w = null, ae = null;
            if (p != null) for (T in p.ref !== void 0 && (ae = p.ref), p.key !== void 0 && (w = "" + p.key), p) le.call(p, T) && !ye.hasOwnProperty(T) && (F[T] = p[T]);
            var oe = arguments.length - 2;
            if (oe === 1) F.children = R;
            else if (1 < oe) {
              for (var me = Array(oe), he = 0; he < oe; he++) me[he] = arguments[he + 2];
              F.children = me;
            }
            if (s && s.defaultProps) for (T in oe = s.defaultProps, oe) F[T] === void 0 && (F[T] = oe[T]);
            return { $$typeof: v, type: s, key: w, ref: ae, props: F, _owner: re.current };
          }
          function fe(s) {
            return typeof s == "object" && s !== null && s.$$typeof === v;
          }
          function z(s) {
            var p = { "=": "=0", ":": "=2" };
            return "$" + ("" + s).replace(/[=:]/g, function(R) {
              return p[R];
            });
          }
          var H = /\/+/g, K = [];
          function y(s, p, R, T) {
            if (K.length) {
              var F = K.pop();
              return F.result = s, F.keyPrefix = p, F.func = R, F.context = T, F.count = 0, F;
            }
            return { result: s, keyPrefix: p, func: R, context: T, count: 0 };
          }
          function U(s) {
            s.result = null, s.keyPrefix = null, s.func = null, s.context = null, s.count = 0, 10 > K.length && K.push(s);
          }
          function $(s, p, R, T) {
            var F = typeof s;
            (F === "undefined" || F === "boolean") && (s = null);
            var w = !1;
            if (s === null) w = !0;
            else switch (F) {
              case "string":
              case "number":
                w = !0;
                break;
              case "object":
                switch (s.$$typeof) {
                  case v:
                  case C:
                    w = !0;
                }
            }
            if (w) return R(T, s, p === "" ? "." + i(s, 0) : p), 1;
            if (w = 0, p = p === "" ? "." : p + ":", Array.isArray(s)) for (var ae = 0; ae < s.length; ae++) {
              F = s[ae];
              var oe = p + i(F, ae);
              w += $(F, oe, R, T);
            }
            else if (s === null || typeof s > "u" ? oe = null : (oe = te && s[te] || s["@@iterator"], oe = typeof oe == "function" ? oe : null), typeof oe == "function") for (s = oe.call(s), ae = 0; !(F = s.next()).done; ) F = F.value, oe = p + i(F, ae++), w += $(F, oe, R, T);
            else F === "object" && (R = "" + s, J("31", R === "[object Object]" ? "object with keys {" + Object.keys(s).join(", ") + "}" : R, ""));
            return w;
          }
          function i(s, p) {
            return typeof s == "object" && s !== null && s.key != null ? z(s.key) : p.toString(36);
          }
          function h(s, p) {
            s.func.call(s.context, p, s.count++);
          }
          function d(s, p, R) {
            var T = s.result, F = s.keyPrefix;
            s = s.func.call(s.context, p, s.count++), Array.isArray(s) ? S(s, T, R, g.thatReturnsArgument) : s != null && (fe(s) && (p = F + (!s.key || p && p.key === s.key ? "" : ("" + s.key).replace(H, "$&/") + "/") + R, s = { $$typeof: v, type: s.type, key: p, ref: s.ref, props: s.props, _owner: s._owner }), T.push(s));
          }
          function S(s, p, R, T, F) {
            var w = "";
            R != null && (w = ("" + R).replace(H, "$&/") + "/"), p = y(p, w, T, F), s == null || $(s, "", d, p), U(p);
          }
          var M = { Children: { map: function(s, p, R) {
            if (s == null) return s;
            var T = [];
            return S(s, T, null, p, R), T;
          }, forEach: function(s, p, R) {
            if (s == null) return s;
            p = y(null, null, p, R), s == null || $(s, "", h, p), U(p);
          }, count: function(s) {
            return s == null ? 0 : $(s, "", g.thatReturnsNull, null);
          }, toArray: function(s) {
            var p = [];
            return S(s, p, null, g.thatReturnsArgument), p;
          }, only: function(s) {
            return fe(s) || J("143"), s;
          } }, createRef: function() {
            return { current: null };
          }, Component: m, PureComponent: G, createContext: function(s, p) {
            return p === void 0 && (p = null), s = {
              $$typeof: A,
              _calculateChangedBits: p,
              _defaultValue: s,
              _currentValue: s,
              _changedBits: 0,
              Provider: null,
              Consumer: null
            }, s.Provider = { $$typeof: L, _context: s }, s.Consumer = s;
          }, forwardRef: function(s) {
            return { $$typeof: j, render: s };
          }, Fragment: E, StrictMode: D, unstable_AsyncMode: Y, createElement: ce, cloneElement: function(s, p, R) {
            s == null && J("267", s);
            var T = void 0, F = f({}, s.props), w = s.key, ae = s.ref, oe = s._owner;
            if (p != null) {
              p.ref !== void 0 && (ae = p.ref, oe = re.current), p.key !== void 0 && (w = "" + p.key);
              var me = void 0;
              s.type && s.type.defaultProps && (me = s.type.defaultProps);
              for (T in p) le.call(p, T) && !ye.hasOwnProperty(T) && (F[T] = p[T] === void 0 && me !== void 0 ? me[T] : p[T]);
            }
            if (T = arguments.length - 2, T === 1) F.children = R;
            else if (1 < T) {
              me = Array(T);
              for (var he = 0; he < T; he++) me[he] = arguments[he + 2];
              F.children = me;
            }
            return { $$typeof: v, type: s.type, key: w, ref: ae, props: F, _owner: oe };
          }, createFactory: function(s) {
            var p = ce.bind(null, s);
            return p.type = s, p;
          }, isValidElement: fe, version: "16.3.2", __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: { ReactCurrentOwner: re, assign: f } }, I = Object.freeze({ default: M }), k = I && M || I;
          r.exports = k.default ? k.default : k;
        },
        /* 10 */
        /***/
        function(r, o, u) {
          /** @license React v16.3.2
           * react.development.js
           *
           * Copyright (c) 2013-present, Facebook, Inc.
           *
           * This source code is licensed under the MIT license found in the
           * LICENSE file in the root directory of this source tree.
           */
          process.env.NODE_ENV !== "production" && function() {
            var f = u(2), b = u(0), l = u(5), g = u(3), O = u(1), v = u(6), C = "16.3.2", E = typeof Symbol == "function" && Symbol.for, D = E ? Symbol.for("react.element") : 60103, L = E ? Symbol.for("react.call") : 60104, A = E ? Symbol.for("react.return") : 60105, Y = E ? Symbol.for("react.portal") : 60106, j = E ? Symbol.for("react.fragment") : 60107, te = E ? Symbol.for("react.strict_mode") : 60108, J = E ? Symbol.for("react.provider") : 60109, N = E ? Symbol.for("react.context") : 60110, m = E ? Symbol.for("react.async_mode") : 60111, X = E ? Symbol.for("react.forward_ref") : 60112, G = typeof Symbol == "function" && Symbol.iterator, q = "@@iterator";
            function re(t) {
              if (t === null || typeof t > "u")
                return null;
              var c = G && t[G] || t[q];
              return typeof c == "function" ? c : null;
            }
            var le = function() {
            };
            {
              var ye = function(t) {
                for (var c = arguments.length, x = Array(c > 1 ? c - 1 : 0), _ = 1; _ < c; _++)
                  x[_ - 1] = arguments[_];
                var W = 0, se = "Warning: " + t.replace(/%s/g, function() {
                  return x[W++];
                });
                typeof console < "u" && console.warn(se);
                try {
                  throw new Error(se);
                } catch {
                }
              };
              le = function(t, c) {
                if (c === void 0)
                  throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
                if (!t) {
                  for (var x = arguments.length, _ = Array(x > 2 ? x - 2 : 0), W = 2; W < x; W++)
                    _[W - 2] = arguments[W];
                  ye.apply(void 0, [c].concat(_));
                }
              };
            }
            var ce = le, fe = {};
            function z(t, c) {
              {
                var x = t.constructor, _ = x && (x.displayName || x.name) || "ReactClass", W = _ + "." + c;
                if (fe[W])
                  return;
                g(!1, "Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", c, _), fe[W] = !0;
              }
            }
            var H = {
              /**
               * Checks whether or not this composite component is mounted.
               * @param {ReactClass} publicInstance The instance we want to test.
               * @return {boolean} True if mounted, false otherwise.
               * @protected
               * @final
               */
              isMounted: function(t) {
                return !1;
              },
              /**
               * Forces an update. This should only be invoked when it is known with
               * certainty that we are **not** in a DOM transaction.
               *
               * You may want to call this when you know that some deeper aspect of the
               * component's state has changed but `setState` was not called.
               *
               * This will not invoke `shouldComponentUpdate`, but it will invoke
               * `componentWillUpdate` and `componentDidUpdate`.
               *
               * @param {ReactClass} publicInstance The instance that should rerender.
               * @param {?function} callback Called after component is updated.
               * @param {?string} callerName name of the calling function in the public API.
               * @internal
               */
              enqueueForceUpdate: function(t, c, x) {
                z(t, "forceUpdate");
              },
              /**
               * Replaces all of the state. Always use this or `setState` to mutate state.
               * You should treat `this.state` as immutable.
               *
               * There is no guarantee that `this.state` will be immediately updated, so
               * accessing `this.state` after calling this method may return the old value.
               *
               * @param {ReactClass} publicInstance The instance that should rerender.
               * @param {object} completeState Next state.
               * @param {?function} callback Called after component is updated.
               * @param {?string} callerName name of the calling function in the public API.
               * @internal
               */
              enqueueReplaceState: function(t, c, x, _) {
                z(t, "replaceState");
              },
              /**
               * Sets a subset of the state. This only exists because _pendingState is
               * internal. This provides a merging strategy that is not available to deep
               * properties which is confusing. TODO: Expose pendingState or don't use it
               * during the merge.
               *
               * @param {ReactClass} publicInstance The instance that should rerender.
               * @param {object} partialState Next partial state to be merged with state.
               * @param {?function} callback Called after component is updated.
               * @param {?string} Name of the calling function in the public API.
               * @internal
               */
              enqueueSetState: function(t, c, x, _) {
                z(t, "setState");
              }
            };
            function K(t, c, x) {
              this.props = t, this.context = c, this.refs = l, this.updater = x || H;
            }
            K.prototype.isReactComponent = {}, K.prototype.setState = function(t, c) {
              typeof t == "object" || typeof t == "function" || t == null || b(!1, "setState(...): takes an object of state variables to update or a function which returns an object of state variables."), this.updater.enqueueSetState(this, t, c, "setState");
            }, K.prototype.forceUpdate = function(t) {
              this.updater.enqueueForceUpdate(this, t, "forceUpdate");
            };
            {
              var y = {
                isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
                replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
              }, U = function(t, c) {
                Object.defineProperty(K.prototype, t, {
                  get: function() {
                    ce(!1, "%s(...) is deprecated in plain JavaScript React classes. %s", c[0], c[1]);
                  }
                });
              };
              for (var $ in y)
                y.hasOwnProperty($) && U($, y[$]);
            }
            function i() {
            }
            i.prototype = K.prototype;
            function h(t, c, x) {
              this.props = t, this.context = c, this.refs = l, this.updater = x || H;
            }
            var d = h.prototype = new i();
            d.constructor = h, f(d, K.prototype), d.isPureReactComponent = !0;
            function S() {
              var t = {
                current: null
              };
              return Object.seal(t), t;
            }
            var M = {
              /**
               * @internal
               * @type {ReactComponent}
               */
              current: null
            }, I = Object.prototype.hasOwnProperty, k = {
              key: !0,
              ref: !0,
              __self: !0,
              __source: !0
            }, s = void 0, p = void 0;
            function R(t) {
              if (I.call(t, "ref")) {
                var c = Object.getOwnPropertyDescriptor(t, "ref").get;
                if (c && c.isReactWarning)
                  return !1;
              }
              return t.ref !== void 0;
            }
            function T(t) {
              if (I.call(t, "key")) {
                var c = Object.getOwnPropertyDescriptor(t, "key").get;
                if (c && c.isReactWarning)
                  return !1;
              }
              return t.key !== void 0;
            }
            function F(t, c) {
              var x = function() {
                s || (s = !0, g(!1, "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", c));
              };
              x.isReactWarning = !0, Object.defineProperty(t, "key", {
                get: x,
                configurable: !0
              });
            }
            function w(t, c) {
              var x = function() {
                p || (p = !0, g(!1, "%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", c));
              };
              x.isReactWarning = !0, Object.defineProperty(t, "ref", {
                get: x,
                configurable: !0
              });
            }
            var ae = function(t, c, x, _, W, se, ne) {
              var Q = {
                // This tag allows us to uniquely identify this as a React Element
                $$typeof: D,
                // Built-in properties that belong on the element
                type: t,
                key: c,
                ref: x,
                props: ne,
                // Record the component responsible for creating this element.
                _owner: se
              };
              return Q._store = {}, Object.defineProperty(Q._store, "validated", {
                configurable: !1,
                enumerable: !1,
                writable: !0,
                value: !1
              }), Object.defineProperty(Q, "_self", {
                configurable: !1,
                enumerable: !1,
                writable: !1,
                value: _
              }), Object.defineProperty(Q, "_source", {
                configurable: !1,
                enumerable: !1,
                writable: !1,
                value: W
              }), Object.freeze && (Object.freeze(Q.props), Object.freeze(Q)), Q;
            };
            function oe(t, c, x) {
              var _ = void 0, W = {}, se = null, ne = null, Q = null, ge = null;
              if (c != null) {
                R(c) && (ne = c.ref), T(c) && (se = "" + c.key), Q = c.__self === void 0 ? null : c.__self, ge = c.__source === void 0 ? null : c.__source;
                for (_ in c)
                  I.call(c, _) && !k.hasOwnProperty(_) && (W[_] = c[_]);
              }
              var Ce = arguments.length - 2;
              if (Ce === 1)
                W.children = x;
              else if (Ce > 1) {
                for (var Oe = Array(Ce), we = 0; we < Ce; we++)
                  Oe[we] = arguments[we + 2];
                Object.freeze && Object.freeze(Oe), W.children = Oe;
              }
              if (t && t.defaultProps) {
                var Le = t.defaultProps;
                for (_ in Le)
                  W[_] === void 0 && (W[_] = Le[_]);
              }
              if ((se || ne) && (typeof W.$$typeof > "u" || W.$$typeof !== D)) {
                var Ae = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
                se && F(W, Ae), ne && w(W, Ae);
              }
              return ae(t, se, ne, Q, ge, M.current, W);
            }
            function me(t, c) {
              var x = ae(t.type, c, t.ref, t._self, t._source, t._owner, t.props);
              return x;
            }
            function he(t, c, x) {
              t == null && b(!1, "React.cloneElement(...): The argument must be a React element, but you passed %s.", t);
              var _ = void 0, W = f({}, t.props), se = t.key, ne = t.ref, Q = t._self, ge = t._source, Ce = t._owner;
              if (c != null) {
                R(c) && (ne = c.ref, Ce = M.current), T(c) && (se = "" + c.key);
                var Oe = void 0;
                t.type && t.type.defaultProps && (Oe = t.type.defaultProps);
                for (_ in c)
                  I.call(c, _) && !k.hasOwnProperty(_) && (c[_] === void 0 && Oe !== void 0 ? W[_] = Oe[_] : W[_] = c[_]);
              }
              var we = arguments.length - 2;
              if (we === 1)
                W.children = x;
              else if (we > 1) {
                for (var Le = Array(we), Ae = 0; Ae < we; Ae++)
                  Le[Ae] = arguments[Ae + 2];
                W.children = Le;
              }
              return ae(t.type, se, ne, Q, ge, Ce, W);
            }
            function je(t) {
              return typeof t == "object" && t !== null && t.$$typeof === D;
            }
            var Me = {};
            Me.getCurrentStack = null, Me.getStackAddendum = function() {
              var t = Me.getCurrentStack;
              return t ? t() : null;
            };
            var Fe = ".", Dt = ":";
            function kt(t) {
              var c = /[=:]/g, x = {
                "=": "=0",
                ":": "=2"
              }, _ = ("" + t).replace(c, function(W) {
                return x[W];
              });
              return "$" + _;
            }
            var Be = !1, Nt = /\/+/g;
            function yt(t) {
              return ("" + t).replace(Nt, "$&/");
            }
            var mt = 10, Ie = [];
            function et(t, c, x, _) {
              if (Ie.length) {
                var W = Ie.pop();
                return W.result = t, W.keyPrefix = c, W.func = x, W.context = _, W.count = 0, W;
              } else
                return {
                  result: t,
                  keyPrefix: c,
                  func: x,
                  context: _,
                  count: 0
                };
            }
            function ht(t) {
              t.result = null, t.keyPrefix = null, t.func = null, t.context = null, t.count = 0, Ie.length < mt && Ie.push(t);
            }
            function Ke(t, c, x, _) {
              var W = typeof t;
              (W === "undefined" || W === "boolean") && (t = null);
              var se = !1;
              if (t === null)
                se = !0;
              else
                switch (W) {
                  case "string":
                  case "number":
                    se = !0;
                    break;
                  case "object":
                    switch (t.$$typeof) {
                      case D:
                      case Y:
                        se = !0;
                    }
                }
              if (se)
                return x(
                  _,
                  t,
                  // If it's the only child, treat the name as if it was wrapped in an array
                  // so that it's consistent if the number of children grows.
                  c === "" ? Fe + tt(t, 0) : c
                ), 1;
              var ne = void 0, Q = void 0, ge = 0, Ce = c === "" ? Fe : c + Dt;
              if (Array.isArray(t))
                for (var Oe = 0; Oe < t.length; Oe++)
                  ne = t[Oe], Q = Ce + tt(ne, Oe), ge += Ke(ne, Q, x, _);
              else {
                var we = re(t);
                if (typeof we == "function") {
                  we === t.entries && (Be || g(!1, "Using Maps as children is unsupported and will likely yield unexpected results. Convert it to a sequence/iterable of keyed ReactElements instead.%s", Me.getStackAddendum()), Be = !0);
                  for (var Le = we.call(t), Ae = void 0, Qn = 0; !(Ae = Le.next()).done; )
                    ne = Ae.value, Q = Ce + tt(ne, Qn++), ge += Ke(ne, Q, x, _);
                } else if (W === "object") {
                  var cn = "";
                  cn = " If you meant to render a collection of children, use an array instead." + Me.getStackAddendum();
                  var fn = "" + t;
                  b(!1, "Objects are not valid as a React child (found: %s).%s", fn === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : fn, cn);
                }
              }
              return ge;
            }
            function Je(t, c, x) {
              return t == null ? 0 : Ke(t, "", c, x);
            }
            function tt(t, c) {
              return typeof t == "object" && t !== null && t.key != null ? kt(t.key) : c.toString(36);
            }
            function $t(t, c, x) {
              var _ = t.func, W = t.context;
              _.call(W, c, t.count++);
            }
            function Ft(t, c, x) {
              if (t == null)
                return t;
              var _ = et(null, null, c, x);
              Je(t, $t, _), ht(_);
            }
            function It(t, c, x) {
              var _ = t.result, W = t.keyPrefix, se = t.func, ne = t.context, Q = se.call(ne, c, t.count++);
              Array.isArray(Q) ? nt(Q, _, x, O.thatReturnsArgument) : Q != null && (je(Q) && (Q = me(
                Q,
                // Keep both the (mapped) and old keys if they differ, just as
                // traverseAllChildren used to do for objects as children
                W + (Q.key && (!c || c.key !== Q.key) ? yt(Q.key) + "/" : "") + x
              )), _.push(Q));
            }
            function nt(t, c, x, _, W) {
              var se = "";
              x != null && (se = yt(x) + "/");
              var ne = et(c, se, _, W);
              Je(t, It, ne), ht(ne);
            }
            function Lt(t, c, x) {
              if (t == null)
                return t;
              var _ = [];
              return nt(t, _, null, c, x), _;
            }
            function Wt(t, c) {
              return Je(t, O.thatReturnsNull, null);
            }
            function rt(t) {
              var c = [];
              return nt(t, c, null, O.thatReturnsArgument), c;
            }
            function gt(t) {
              return je(t) || b(!1, "React.Children.only expected to receive a single React element child."), t;
            }
            function Ne(t, c) {
              c === void 0 ? c = null : c === null || typeof c == "function" || g(!1, "createContext: Expected the optional second argument to be a function. Instead received: %s", c);
              var x = {
                $$typeof: N,
                _calculateChangedBits: c,
                _defaultValue: t,
                _currentValue: t,
                _changedBits: 0,
                // These are circular
                Provider: null,
                Consumer: null
              };
              return x.Provider = {
                $$typeof: J,
                _context: x
              }, x.Consumer = x, x._currentRenderer = null, x;
            }
            function at(t) {
              return typeof t != "function" && g(!1, "forwardRef requires a render function but was given %s.", t === null ? "null" : typeof t), {
                $$typeof: X,
                render: t
              };
            }
            var ot = function(t, c, x) {
              return `
    in ` + (t || "Unknown") + (c ? " (at " + c.fileName.replace(/^.*[\\\/]/, "") + ":" + c.lineNumber + ")" : x ? " (created by " + x + ")" : "");
            };
            function bt(t) {
              return typeof t == "string" || typeof t == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
              t === j || t === m || t === te || typeof t == "object" && t !== null && (t.$$typeof === J || t.$$typeof === N || t.$$typeof === X);
            }
            function it(t) {
              var c = t.type;
              if (typeof c == "function")
                return c.displayName || c.name;
              if (typeof c == "string")
                return c;
              switch (c) {
                case j:
                  return "ReactFragment";
                case Y:
                  return "ReactPortal";
                case L:
                  return "ReactCall";
                case A:
                  return "ReactReturn";
              }
              if (typeof c == "object" && c !== null)
                switch (c.$$typeof) {
                  case X:
                    var x = c.render.displayName || c.render.name || "";
                    return x !== "" ? "ForwardRef(" + x + ")" : "ForwardRef";
                }
              return null;
            }
            var Ee = void 0, st = void 0, ut = function() {
            }, De = function() {
            };
            Ee = null, st = !1, ut = function(t) {
              return t == null ? "#empty" : typeof t == "string" || typeof t == "number" ? "#text" : typeof t.type == "string" ? t.type : t.type === j ? "React.Fragment" : t.type.displayName || t.type.name || "Unknown";
            }, De = function() {
              var t = "";
              if (Ee) {
                var c = ut(Ee), x = Ee._owner;
                t += ot(c, Ee._source, x && it(x));
              }
              return t += Me.getStackAddendum() || "", t;
            };
            function Et() {
              if (M.current) {
                var t = it(M.current);
                if (t)
                  return `

Check the render method of \`` + t + "`.";
              }
              return "";
            }
            function Ut(t) {
              if (t != null && t.__source !== void 0) {
                var c = t.__source, x = c.fileName.replace(/^.*[\\\/]/, ""), _ = c.lineNumber;
                return `

Check your code at ` + x + ":" + _ + ".";
              }
              return "";
            }
            var lt = {};
            function Ot(t) {
              var c = Et();
              if (!c) {
                var x = typeof t == "string" ? t : t.displayName || t.name;
                x && (c = `

Check the top-level render call using <` + x + ">.");
              }
              return c;
            }
            function wt(t, c) {
              if (!(!t._store || t._store.validated || t.key != null)) {
                t._store.validated = !0;
                var x = Ot(c);
                if (!lt[x]) {
                  lt[x] = !0;
                  var _ = "";
                  t && t._owner && t._owner !== M.current && (_ = " It was passed a child from " + it(t._owner) + "."), Ee = t, g(!1, 'Each child in an array or iterator should have a unique "key" prop.%s%s See https://fb.me/react-warning-keys for more information.%s', x, _, De()), Ee = null;
                }
              }
            }
            function St(t, c) {
              if (typeof t == "object") {
                if (Array.isArray(t))
                  for (var x = 0; x < t.length; x++) {
                    var _ = t[x];
                    je(_) && wt(_, c);
                  }
                else if (je(t))
                  t._store && (t._store.validated = !0);
                else if (t) {
                  var W = re(t);
                  if (typeof W == "function" && W !== t.entries)
                    for (var se = W.call(t), ne = void 0; !(ne = se.next()).done; )
                      je(ne.value) && wt(ne.value, c);
                }
              }
            }
            function Ct(t) {
              var c = t.type;
              if (typeof c == "function") {
                var x = c.displayName || c.name, _ = c.propTypes;
                _ ? (Ee = t, v(_, t.props, "prop", x, De), Ee = null) : c.PropTypes !== void 0 && !st && (st = !0, g(!1, "Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", x || "Unknown")), typeof c.getDefaultProps == "function" && (c.getDefaultProps.isReactClassApproved || g(!1, "getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead."));
              }
            }
            function Vt(t) {
              Ee = t;
              for (var c = Object.keys(t.props), x = 0; x < c.length; x++) {
                var _ = c[x];
                if (_ !== "children" && _ !== "key") {
                  g(!1, "Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.%s", _, De());
                  break;
                }
              }
              t.ref !== null && g(!1, "Invalid attribute `ref` supplied to `React.Fragment`.%s", De()), Ee = null;
            }
            function a(t, c, x) {
              var _ = bt(t);
              if (!_) {
                var W = "";
                (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (W += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
                var se = Ut(c);
                se ? W += se : W += Et(), W += De() || "";
                var ne = void 0;
                t === null ? ne = "null" : Array.isArray(t) ? ne = "array" : ne = typeof t, g(!1, "React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ne, W);
              }
              var Q = oe.apply(this, arguments);
              if (Q == null)
                return Q;
              if (_)
                for (var ge = 2; ge < arguments.length; ge++)
                  St(arguments[ge], t);
              return t === j ? Vt(Q) : Ct(Q), Q;
            }
            function P(t) {
              var c = a.bind(null, t);
              return c.type = t, Object.defineProperty(c, "type", {
                enumerable: !1,
                get: function() {
                  return ce(!1, "Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
                    value: t
                  }), t;
                }
              }), c;
            }
            function V(t, c, x) {
              for (var _ = he.apply(this, arguments), W = 2; W < arguments.length; W++)
                St(arguments[W], _.type);
              return Ct(_), _;
            }
            var Z = {
              Children: {
                map: Lt,
                forEach: Ft,
                count: Wt,
                toArray: rt,
                only: gt
              },
              createRef: S,
              Component: K,
              PureComponent: h,
              createContext: Ne,
              forwardRef: at,
              Fragment: j,
              StrictMode: te,
              unstable_AsyncMode: m,
              createElement: a,
              cloneElement: V,
              createFactory: P,
              isValidElement: je,
              version: C,
              __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
                ReactCurrentOwner: M,
                // Used by renderers to avoid bundling object-assign twice in UMD bundles:
                assign: f
              }
            };
            f(Z.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, {
              // These should not be included in production.
              ReactDebugCurrentFrame: Me,
              // Shim for React DOM 16.0.0 which still destructured (but not used) this.
              // TODO: remove in React 17.0.
              ReactComponentTreeHook: {}
            });
            var ue = Object.freeze({
              default: Z
            }), de = ue && Z || ue, ie = de.default ? de.default : de;
            r.exports = ie;
          }();
        },
        /* 11 */
        /***/
        function(r, o, u) {
          if (process.env.NODE_ENV !== "production") {
            var f = typeof Symbol == "function" && Symbol.for && Symbol.for("react.element") || 60103, b = function(g) {
              return typeof g == "object" && g !== null && g.$$typeof === f;
            }, l = !0;
            r.exports = u(12)(b, l);
          } else
            r.exports = u(13)();
        },
        /* 12 */
        /***/
        function(r, o, u) {
          var f = u(1), b = u(0), l = u(3), g = u(2), O = u(4), v = u(6);
          r.exports = function(C, E) {
            var D = typeof Symbol == "function" && Symbol.iterator, L = "@@iterator";
            function A(d) {
              var S = d && (D && d[D] || d[L]);
              if (typeof S == "function")
                return S;
            }
            var Y = "<<anonymous>>", j = {
              array: m("array"),
              bool: m("boolean"),
              func: m("function"),
              number: m("number"),
              object: m("object"),
              string: m("string"),
              symbol: m("symbol"),
              any: X(),
              arrayOf: G,
              element: q(),
              instanceOf: re,
              node: fe(),
              objectOf: ye,
              oneOf: le,
              oneOfType: ce,
              shape: z,
              exact: H
            };
            function te(d, S) {
              return d === S ? d !== 0 || 1 / d === 1 / S : d !== d && S !== S;
            }
            function J(d) {
              this.message = d, this.stack = "";
            }
            J.prototype = Error.prototype;
            function N(d) {
              if (process.env.NODE_ENV !== "production")
                var S = {}, M = 0;
              function I(s, p, R, T, F, w, ae) {
                if (T = T || Y, w = w || R, ae !== O) {
                  if (E)
                    b(
                      !1,
                      "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                    );
                  else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
                    var oe = T + ":" + R;
                    !S[oe] && // Avoid spamming the console because they are often not actionable except for lib authors
                    M < 3 && (l(
                      !1,
                      "You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.",
                      w,
                      T
                    ), S[oe] = !0, M++);
                  }
                }
                return p[R] == null ? s ? p[R] === null ? new J("The " + F + " `" + w + "` is marked as required " + ("in `" + T + "`, but its value is `null`.")) : new J("The " + F + " `" + w + "` is marked as required in " + ("`" + T + "`, but its value is `undefined`.")) : null : d(p, R, T, F, w);
              }
              var k = I.bind(null, !1);
              return k.isRequired = I.bind(null, !0), k;
            }
            function m(d) {
              function S(M, I, k, s, p, R) {
                var T = M[I], F = U(T);
                if (F !== d) {
                  var w = $(T);
                  return new J("Invalid " + s + " `" + p + "` of type " + ("`" + w + "` supplied to `" + k + "`, expected ") + ("`" + d + "`."));
                }
                return null;
              }
              return N(S);
            }
            function X() {
              return N(f.thatReturnsNull);
            }
            function G(d) {
              function S(M, I, k, s, p) {
                if (typeof d != "function")
                  return new J("Property `" + p + "` of component `" + k + "` has invalid PropType notation inside arrayOf.");
                var R = M[I];
                if (!Array.isArray(R)) {
                  var T = U(R);
                  return new J("Invalid " + s + " `" + p + "` of type " + ("`" + T + "` supplied to `" + k + "`, expected an array."));
                }
                for (var F = 0; F < R.length; F++) {
                  var w = d(R, F, k, s, p + "[" + F + "]", O);
                  if (w instanceof Error)
                    return w;
                }
                return null;
              }
              return N(S);
            }
            function q() {
              function d(S, M, I, k, s) {
                var p = S[M];
                if (!C(p)) {
                  var R = U(p);
                  return new J("Invalid " + k + " `" + s + "` of type " + ("`" + R + "` supplied to `" + I + "`, expected a single ReactElement."));
                }
                return null;
              }
              return N(d);
            }
            function re(d) {
              function S(M, I, k, s, p) {
                if (!(M[I] instanceof d)) {
                  var R = d.name || Y, T = h(M[I]);
                  return new J("Invalid " + s + " `" + p + "` of type " + ("`" + T + "` supplied to `" + k + "`, expected ") + ("instance of `" + R + "`."));
                }
                return null;
              }
              return N(S);
            }
            function le(d) {
              if (!Array.isArray(d))
                return process.env.NODE_ENV !== "production" && l(!1, "Invalid argument supplied to oneOf, expected an instance of array."), f.thatReturnsNull;
              function S(M, I, k, s, p) {
                for (var R = M[I], T = 0; T < d.length; T++)
                  if (te(R, d[T]))
                    return null;
                var F = JSON.stringify(d);
                return new J("Invalid " + s + " `" + p + "` of value `" + R + "` " + ("supplied to `" + k + "`, expected one of " + F + "."));
              }
              return N(S);
            }
            function ye(d) {
              function S(M, I, k, s, p) {
                if (typeof d != "function")
                  return new J("Property `" + p + "` of component `" + k + "` has invalid PropType notation inside objectOf.");
                var R = M[I], T = U(R);
                if (T !== "object")
                  return new J("Invalid " + s + " `" + p + "` of type " + ("`" + T + "` supplied to `" + k + "`, expected an object."));
                for (var F in R)
                  if (R.hasOwnProperty(F)) {
                    var w = d(R, F, k, s, p + "." + F, O);
                    if (w instanceof Error)
                      return w;
                  }
                return null;
              }
              return N(S);
            }
            function ce(d) {
              if (!Array.isArray(d))
                return process.env.NODE_ENV !== "production" && l(!1, "Invalid argument supplied to oneOfType, expected an instance of array."), f.thatReturnsNull;
              for (var S = 0; S < d.length; S++) {
                var M = d[S];
                if (typeof M != "function")
                  return l(
                    !1,
                    "Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.",
                    i(M),
                    S
                  ), f.thatReturnsNull;
              }
              function I(k, s, p, R, T) {
                for (var F = 0; F < d.length; F++) {
                  var w = d[F];
                  if (w(k, s, p, R, T, O) == null)
                    return null;
                }
                return new J("Invalid " + R + " `" + T + "` supplied to " + ("`" + p + "`."));
              }
              return N(I);
            }
            function fe() {
              function d(S, M, I, k, s) {
                return K(S[M]) ? null : new J("Invalid " + k + " `" + s + "` supplied to " + ("`" + I + "`, expected a ReactNode."));
              }
              return N(d);
            }
            function z(d) {
              function S(M, I, k, s, p) {
                var R = M[I], T = U(R);
                if (T !== "object")
                  return new J("Invalid " + s + " `" + p + "` of type `" + T + "` " + ("supplied to `" + k + "`, expected `object`."));
                for (var F in d) {
                  var w = d[F];
                  if (w) {
                    var ae = w(R, F, k, s, p + "." + F, O);
                    if (ae)
                      return ae;
                  }
                }
                return null;
              }
              return N(S);
            }
            function H(d) {
              function S(M, I, k, s, p) {
                var R = M[I], T = U(R);
                if (T !== "object")
                  return new J("Invalid " + s + " `" + p + "` of type `" + T + "` " + ("supplied to `" + k + "`, expected `object`."));
                var F = g({}, M[I], d);
                for (var w in F) {
                  var ae = d[w];
                  if (!ae)
                    return new J(
                      "Invalid " + s + " `" + p + "` key `" + w + "` supplied to `" + k + "`.\nBad object: " + JSON.stringify(M[I], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(d), null, "  ")
                    );
                  var oe = ae(R, w, k, s, p + "." + w, O);
                  if (oe)
                    return oe;
                }
                return null;
              }
              return N(S);
            }
            function K(d) {
              switch (typeof d) {
                case "number":
                case "string":
                case "undefined":
                  return !0;
                case "boolean":
                  return !d;
                case "object":
                  if (Array.isArray(d))
                    return d.every(K);
                  if (d === null || C(d))
                    return !0;
                  var S = A(d);
                  if (S) {
                    var M = S.call(d), I;
                    if (S !== d.entries) {
                      for (; !(I = M.next()).done; )
                        if (!K(I.value))
                          return !1;
                    } else
                      for (; !(I = M.next()).done; ) {
                        var k = I.value;
                        if (k && !K(k[1]))
                          return !1;
                      }
                  } else
                    return !1;
                  return !0;
                default:
                  return !1;
              }
            }
            function y(d, S) {
              return d === "symbol" || S["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && S instanceof Symbol;
            }
            function U(d) {
              var S = typeof d;
              return Array.isArray(d) ? "array" : d instanceof RegExp ? "object" : y(S, d) ? "symbol" : S;
            }
            function $(d) {
              if (typeof d > "u" || d === null)
                return "" + d;
              var S = U(d);
              if (S === "object") {
                if (d instanceof Date)
                  return "date";
                if (d instanceof RegExp)
                  return "regexp";
              }
              return S;
            }
            function i(d) {
              var S = $(d);
              switch (S) {
                case "array":
                case "object":
                  return "an " + S;
                case "boolean":
                case "date":
                case "regexp":
                  return "a " + S;
                default:
                  return S;
              }
            }
            function h(d) {
              return !d.constructor || !d.constructor.name ? Y : d.constructor.name;
            }
            return j.checkPropTypes = v, j.PropTypes = j, j;
          };
        },
        /* 13 */
        /***/
        function(r, o, u) {
          var f = u(1), b = u(0), l = u(4);
          r.exports = function() {
            function g(C, E, D, L, A, Y) {
              Y !== l && b(
                !1,
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
              );
            }
            g.isRequired = g;
            function O() {
              return g;
            }
            var v = {
              array: g,
              bool: g,
              func: g,
              number: g,
              object: g,
              string: g,
              symbol: g,
              any: g,
              arrayOf: O,
              element: g,
              instanceOf: O,
              node: g,
              objectOf: O,
              oneOf: O,
              oneOfType: O,
              shape: O,
              exact: O
            };
            return v.checkPropTypes = f, v.PropTypes = v, v;
          };
        },
        /* 14 */
        /***/
        function(r, o, u) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var f = u(15);
          Object.defineProperty(o, "blank", {
            enumerable: !0,
            get: function() {
              return L(f).default;
            }
          });
          var b = u(16);
          Object.defineProperty(o, "balls", {
            enumerable: !0,
            get: function() {
              return L(b).default;
            }
          });
          var l = u(17);
          Object.defineProperty(o, "bars", {
            enumerable: !0,
            get: function() {
              return L(l).default;
            }
          });
          var g = u(18);
          Object.defineProperty(o, "bubbles", {
            enumerable: !0,
            get: function() {
              return L(g).default;
            }
          });
          var O = u(19);
          Object.defineProperty(o, "cubes", {
            enumerable: !0,
            get: function() {
              return L(O).default;
            }
          });
          var v = u(20);
          Object.defineProperty(o, "cylon", {
            enumerable: !0,
            get: function() {
              return L(v).default;
            }
          });
          var C = u(21);
          Object.defineProperty(o, "spin", {
            enumerable: !0,
            get: function() {
              return L(C).default;
            }
          });
          var E = u(22);
          Object.defineProperty(o, "spinningBubbles", {
            enumerable: !0,
            get: function() {
              return L(E).default;
            }
          });
          var D = u(23);
          Object.defineProperty(o, "spokes", {
            enumerable: !0,
            get: function() {
              return L(D).default;
            }
          });
          function L(A) {
            return A && A.__esModule ? A : { default: A };
          }
        },
        /* 15 */
        /***/
        function(r, o) {
          r.exports = `<svg class="icon-blank" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"></svg>
`;
        },
        /* 16 */
        /***/
        function(r, o) {
          r.exports = `<svg class="icon-loading" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path transform="translate(-8 0)" d="M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12"> 
    <animateTransform attributeName="transform" type="translate" values="-8 0; 2 0; 2 0;" dur="0.8s" repeatCount="indefinite" begin="0" keytimes="0;.25;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline"  />
  </path>
  <path transform="translate(2 0)" d="M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12"> 
    <animateTransform attributeName="transform" type="translate" values="2 0; 12 0; 12 0;" dur="0.8s" repeatCount="indefinite" begin="0" keytimes="0;.35;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline"  />
  </path>
  <path transform="translate(12 0)" d="M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12"> 
    <animateTransform attributeName="transform" type="translate" values="12 0; 22 0; 22 0;" dur="0.8s" repeatCount="indefinite" begin="0" keytimes="0;.45;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline"  />
  </path>
  <path transform="translate(24 0)" d="M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12"> 
    <animateTransform attributeName="transform" type="translate" values="22 0; 32 0; 32 0;" dur="0.8s" repeatCount="indefinite" begin="0" keytimes="0;.55;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline"  />
  </path>
</svg>
`;
        },
        /* 17 */
        /***/
        function(r, o) {
          r.exports = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path transform="translate(2)" d="M0 12 V20 H4 V12z"> 
    <animate attributeName="d" values="M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z" dur="1.2s" repeatCount="indefinite" begin="0" keytimes="0;.2;.5;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8" calcMode="spline"  />
  </path>
  <path transform="translate(8)" d="M0 12 V20 H4 V12z">
    <animate attributeName="d" values="M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z" dur="1.2s" repeatCount="indefinite" begin="0.2" keytimes="0;.2;.5;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8" calcMode="spline"  />
  </path>
  <path transform="translate(14)" d="M0 12 V20 H4 V12z">
    <animate attributeName="d" values="M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z" dur="1.2s" repeatCount="indefinite" begin="0.4" keytimes="0;.2;.5;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8" calcMode="spline" />
  </path>
  <path transform="translate(20)" d="M0 12 V20 H4 V12z">
    <animate attributeName="d" values="M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z" dur="1.2s" repeatCount="indefinite" begin="0.6" keytimes="0;.2;.5;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8" calcMode="spline" />
  </path>
  <path transform="translate(26)" d="M0 12 V20 H4 V12z">
    <animate attributeName="d" values="M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z" dur="1.2s" repeatCount="indefinite" begin="0.8" keytimes="0;.2;.5;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8" calcMode="spline" />
  </path>
</svg>
`;
        },
        /* 18 */
        /***/
        function(r, o) {
          r.exports = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <circle transform="translate(8 0)" cx="0" cy="16" r="0"> 
    <animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0"
      keytimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline" />
  </circle>
  <circle transform="translate(16 0)" cx="0" cy="16" r="0"> 
    <animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0.3"
      keytimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline" />
  </circle>
  <circle transform="translate(24 0)" cx="0" cy="16" r="0"> 
    <animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0.6"
      keytimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline" />
  </circle>
</svg>
`;
        },
        /* 19 */
        /***/
        function(r, o) {
          r.exports = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path transform="translate(-8 0)" d="M0 12 V20 H8 V12z"> 
    <animateTransform attributeName="transform" type="translate" values="-8 0; 2 0; 2 0;" dur="0.8s" repeatCount="indefinite" begin="0" keytimes="0;.25;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline"  />
  </path>
  <path transform="translate(2 0)" d="M0 12 V20 H8 V12z"> 
    <animateTransform attributeName="transform" type="translate" values="2 0; 12 0; 12 0;" dur="0.8s" repeatCount="indefinite" begin="0" keytimes="0;.35;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline"  />
  </path>
  <path transform="translate(12 0)" d="M0 12 V20 H8 V12z"> 
    <animateTransform attributeName="transform" type="translate" values="12 0; 22 0; 22 0;" dur="0.8s" repeatCount="indefinite" begin="0" keytimes="0;.45;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline"  />
  </path>
  <path transform="translate(24 0)" d="M0 12 V20 H8 V12z"> 
    <animateTransform attributeName="transform" type="translate" values="22 0; 32 0; 32 0;" dur="0.8s" repeatCount="indefinite" begin="0" keytimes="0;.55;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline"  />
  </path>
</svg>
`;
        },
        /* 20 */
        /***/
        function(r, o) {
          r.exports = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path transform="translate(0 0)" d="M0 12 V20 H4 V12z">
    <animateTransform attributeName="transform" type="translate" values="0 0; 28 0; 0 0; 0 0" dur="1.5s" begin="0" repeatCount="indefinite" keytimes="0;0.3;0.6;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" calcMode="spline" />
  </path>
  <path opacity="0.5" transform="translate(0 0)" d="M0 12 V20 H4 V12z">
    <animateTransform attributeName="transform" type="translate" values="0 0; 28 0; 0 0; 0 0" dur="1.5s" begin="0.1s" repeatCount="indefinite" keytimes="0;0.3;0.6;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" calcMode="spline" />
  </path>
  <path opacity="0.25" transform="translate(0 0)" d="M0 12 V20 H4 V12z">
    <animateTransform attributeName="transform" type="translate" values="0 0; 28 0; 0 0; 0 0" dur="1.5s" begin="0.2s" repeatCount="indefinite" keytimes="0;0.3;0.6;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" calcMode="spline" />
  </path>
</svg>
`;
        },
        /* 21 */
        /***/
        function(r, o) {
          r.exports = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path opacity=".25" d="M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"/>
  <path d="M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z">
    <animateTransform attributeName="transform" type="rotate" from="0 16 16" to="360 16 16" dur="0.8s" repeatCount="indefinite" />
  </path>
</svg>
`;
        },
        /* 22 */
        /***/
        function(r, o) {
          r.exports = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <circle cx="16" cy="3" r="0">
    <animate attributeName="r" values="0;3;0;0" dur="1s" repeatCount="indefinite" begin="0" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" calcMode="spline" />
  </circle>
  <circle transform="rotate(45 16 16)" cx="16" cy="3" r="0">
    <animate attributeName="r" values="0;3;0;0" dur="1s" repeatCount="indefinite" begin="0.125s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" calcMode="spline" />
  </circle>
  <circle transform="rotate(90 16 16)" cx="16" cy="3" r="0">
    <animate attributeName="r" values="0;3;0;0" dur="1s" repeatCount="indefinite" begin="0.25s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" calcMode="spline" />
  </circle>
  <circle transform="rotate(135 16 16)" cx="16" cy="3" r="0">
    <animate attributeName="r" values="0;3;0;0" dur="1s" repeatCount="indefinite" begin="0.375s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" calcMode="spline" />
  </circle>
  <circle transform="rotate(180 16 16)" cx="16" cy="3" r="0">
    <animate attributeName="r" values="0;3;0;0" dur="1s" repeatCount="indefinite" begin="0.5s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" calcMode="spline" />
  </circle>
  <circle transform="rotate(225 16 16)" cx="16" cy="3" r="0">
    <animate attributeName="r" values="0;3;0;0" dur="1s" repeatCount="indefinite" begin="0.625s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" calcMode="spline" />
  </circle>
  <circle transform="rotate(270 16 16)" cx="16" cy="3" r="0">
    <animate attributeName="r" values="0;3;0;0" dur="1s" repeatCount="indefinite" begin="0.75s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" calcMode="spline" />
  </circle>
  <circle transform="rotate(315 16 16)" cx="16" cy="3" r="0">
    <animate attributeName="r" values="0;3;0;0" dur="1s" repeatCount="indefinite" begin="0.875s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" calcMode="spline" />
  </circle>
  <circle transform="rotate(180 16 16)" cx="16" cy="3" r="0">
    <animate attributeName="r" values="0;3;0;0" dur="1s" repeatCount="indefinite" begin="0.5s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" calcMode="spline" />
  </circle>
</svg>
`;
        },
        /* 23 */
        /***/
        function(r, o) {
          r.exports = `<svg id="loading" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path opacity=".1" d="M14 0 H18 V8 H14 z" transform="rotate(0 16 16)">
    <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0"/>
  </path>
  <path opacity=".1" d="M14 0 H18 V8 H14 z" transform="rotate(45 16 16)">
    <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0.125s"/>
  </path>
  <path opacity=".1" d="M14 0 H18 V8 H14 z" transform="rotate(90 16 16)">
    <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0.25s"/>
  </path>
  <path opacity=".1" d="M14 0 H18 V8 H14 z" transform="rotate(135 16 16)">
    <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0.375s"/>
  </path>
  <path opacity=".1" d="M14 0 H18 V8 H14 z" transform="rotate(180 16 16)">
    <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0.5s"/>
  </path>
  <path opacity=".1" d="M14 0 H18 V8 H14 z" transform="rotate(225 16 16)">
    <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0.675s"/>
  </path>
  <path opacity=".1" d="M14 0 H18 V8 H14 z" transform="rotate(270 16 16)">
    <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0.75s"/>
  </path>
  <path opacity=".1" d="M14 0 H18 V8 H14 z" transform="rotate(315 16 16)">
    <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0.875s"/>
  </path>
</svg>
`;
        }
        /******/
      ])
    );
  });
})(Gn);
var wa = Gn.exports;
const Sa = /* @__PURE__ */ Fn(wa), Ca = ({ color: e = "#FFFFFF" }) => /* @__PURE__ */ B.jsxs("svg", { width: "88px", height: "35px", viewBox: "0 0 101 40", children: [
  /* @__PURE__ */ B.jsx("title", { children: "waitly logo" }),
  /* @__PURE__ */ B.jsx("defs", {}),
  /* @__PURE__ */ B.jsx("g", { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ B.jsxs("g", { id: "waitly_logo", fill: e, fillRule: "nonzero", children: [
    /* @__PURE__ */ B.jsx("g", { id: "icon", children: /* @__PURE__ */ B.jsxs("g", { id: "Group-2", children: [
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M0.0335522228,0.0349671968 C10.126655,0.0304872066 20.221214,0.0247272191 30.315773,0.0379344631 C30.3055209,2.11647541 30.3098897,4.19652907 30.3128022,6.27507002 C30.3055209,6.8439706 30.3977313,7.45546018 30.0902275,7.97036816 C29.2203745,9.71250256 28.4134901,11.4897205 27.5098519,13.2156804 C27.457077,9.75776792 27.5098519,6.2999136 27.4835227,2.84200111 C19.2707424,2.84927382 11.0580787,2.8375793 2.84675465,2.84781927 C2.84978367,13.1235788 2.85415245,23.3992801 2.84384213,33.6749815 C11.0551079,33.6663124 19.2664319,33.6632869 27.4776394,33.6749815 C27.4995416,31.617095 27.4878915,29.5574631 27.4835227,27.499344 C27.495231,27.0855558 27.4278353,26.6451204 27.6182559,26.2618776 C28.5042442,24.4919905 29.4151638,22.7353107 30.2924146,20.9622236 C30.3377917,26.1404524 30.2938709,31.3199611 30.314375,36.4981899 C20.2226703,36.4835863 10.1310238,36.4820154 0.0394937622,36.4981899 C0.0233001547,24.3442672 0.0364647421,12.1888899 0.0335522228,0.0349671968 Z",
          id: "Shape"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M31.516663,7.64117615 C32.9547485,7.63099435 34.3913196,7.6279689 35.8295216,7.64117615 C31.8329626,15.5663371 27.7851432,23.4651418 23.8076321,31.3989719 C23.2057891,31.4062446 22.6038296,31.4062446 22.0034428,31.4062446 C20.7806507,28.6415669 19.5460338,25.8815438 18.3305812,23.1140735 C17.1224099,25.8757838 15.8907637,28.6284179 14.6928445,31.3959464 C14.0924578,31.4076409 13.4920128,31.4091537 12.8916261,31.39903 C10.548446,26.7299493 8.20380971,22.0609267 5.85771714,17.3932423 C7.3133943,17.4122677 8.77052773,17.3830605 10.2262631,17.4093004 C11.4065325,20.0277093 12.6088205,22.6386127 13.7980604,25.2540543 C15.0502107,22.5201548 16.268634,19.7718262 17.5061052,17.0320503 C18.0639692,17.0334467 18.6220661,17.0320503 19.1799883,17.0320503 C20.4086637,19.8141243 21.6549308,22.5890419 22.8762666,25.3739668 C25.7656606,19.4675359 28.617017,13.5417888 31.516663,7.64117615 Z",
          id: "Shape"
        }
      )
    ] }) }),
    /* @__PURE__ */ B.jsxs("g", { id: "Group", transform: "translate(33.268608, 4.271845)", children: [
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M12.9050896,11.5159766 L17.3462783,11.5159766 L17.3462783,27.2216945 L12.9050896,27.2216945 L12.9050896,25.1704178 C11.5533133,26.8692496 9.84773973,27.7022654 7.75575212,27.7022654 C5.53519733,27.7022654 3.7008191,26.9010248 2.22055479,25.2982284 C0.739894652,23.6961415 0,21.7088096 0,19.3367055 C0,16.9969286 0.739894652,15.0097543 2.188413,13.4072732 C3.63645634,11.8044768 5.47107207,11.0032362 7.6594059,11.0032362 C9.68695158,11.0032362 11.4568087,11.8365674 12.9050896,13.5353203 L12.9050896,11.5159766 Z M12.0682154,16.2918022 C11.1991994,15.4264593 10.1693952,14.9776637 8.97880289,14.9776637 C7.72361033,14.9776637 6.69396451,15.3942898 5.82486933,16.2597905 C4.98807429,17.1252122 4.56975594,18.1507717 4.56975594,19.3689538 C4.56975594,20.5868993 4.98799512,21.6126165 5.82486933,22.4779595 C6.69396451,23.3436178 7.72353116,23.7601651 8.97880289,23.7601651 C10.1693952,23.7601651 11.1992785,23.3436966 12.0682154,22.4779595 C12.937073,21.6126165 13.3878498,20.5869782 13.3878498,19.4008867 C13.3878498,18.1827835 12.937073,17.1571452 12.0682154,16.2918022 Z",
          id: "Shape"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M21.7474563,5.0410431 C22.7832181,4.01544518 24.4660723,4.01544518 25.5016749,5.0410431 C26.5371979,6.06664101 26.5371979,7.73310951 25.5016749,8.75870743 C24.4660723,9.78422651 22.7832181,9.78422651 21.7474563,8.75870743 C20.7120129,7.73318835 20.7120129,6.06664101 21.7474563,5.0410431 Z M21.3915077,11.4805744 L25.857942,11.4805744 L25.857942,27.184466 L21.3915077,27.184466 L21.3915077,11.4805744 Z",
          id: "Shape"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M29.9678017,15.3820467 L28.2200647,15.3820467 L28.2200647,11.5860531 L29.9678017,11.5860531 L29.9678017,6.21359223 L34.4334712,6.21359223 L34.4334712,11.5860531 L37.5404531,11.5860531 L37.5404531,15.3820467 L34.4334712,15.3820467 L34.4334712,20.079003 C34.4334712,22.7812585 34.8222022,23.9391758 36.3752951,23.9391758 C36.601942,23.9391758 36.8933111,23.9070466 37.1843618,23.8749966 L37.1843618,27.7352485 C36.6991447,27.7993486 36.0516843,27.8317152 35.3076581,27.8317152 C31.9416284,27.8317152 29.9678813,25.386889 29.9678813,21.6553121 L29.9678813,15.3820467 L29.9678017,15.3820467 Z",
          id: "Shape"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M40,0 L44.4460245,0 L44.4460245,19.9663892 C44.4460245,22.5665981 44.9611152,23.8181791 46.5078134,23.8181791 C46.6043335,23.8181791 46.8300224,23.7861197 47.1197411,23.7541392 L47.1197411,27.6060081 C46.6362691,27.6699691 46.1214162,27.7022654 45.6379442,27.7022654 C41.8689073,27.7022654 40,25.1987875 40,21.3467606 L40,0 Z",
          id: "Shape"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "polygon",
        {
          id: "Shape",
          points: "49.4734449 35.7281553 55.2374621 24.9120347 47.7669903 11.5210356 52.9190699 11.5210356 57.6524969 20.5020298 62.1609528 11.5210356 67.184466 11.5210356 54.4324769 35.7281553"
        }
      )
    ] })
  ] }) })
] });
function Ta({ color: e = "#FFFFFF" }) {
  const n = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "10px",
    alignContent: "center"
  };
  return /* @__PURE__ */ B.jsxs("div", { style: n, children: [
    /* @__PURE__ */ B.jsx(Sa, { type: "bubbles", color: e, height: "70px", width: "88px" }),
    /* @__PURE__ */ B.jsx(Ca, { color: e })
  ] });
}
const xa = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], Jt = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
function Ra(e, n, r) {
  if (r && r.length > 0) {
    for (const o of r)
      if (o.date === e)
        return o.begin == null || o.end == null;
  }
  if (n && n.length > 0) {
    const u = (/* @__PURE__ */ new Date(e + "T00:00:00")).getDay(), f = n[u];
    if (f && f.closed)
      return !0;
  }
  return !1;
}
const _a = ({
  minDate: e,
  maxDate: n,
  businessHours: r,
  shifts: o,
  selectedDate: u,
  onSelectDate: f
}) => {
  const [b, l] = ke(!1), [g, O] = ke(() => u ? (/* @__PURE__ */ new Date(u + "T00:00:00")).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear()), [v, C] = ke(() => u ? (/* @__PURE__ */ new Date(u + "T00:00:00")).getMonth() : (/* @__PURE__ */ new Date()).getMonth()), [E, D] = ke(null), L = dn(null), A = dn(null), Y = er(() => {
    var p;
    if (!A.current) return;
    const i = A.current.getBoundingClientRect(), h = 300, d = 6, S = window.innerWidth - h - 8, M = Math.max(8, Math.min(i.left, S)), I = ((p = L.current) == null ? void 0 : p.offsetHeight) || 360, k = i.bottom + d, s = k + I > window.innerHeight && i.top - d - I >= 0 ? i.top - d - I : k;
    D({ top: s, left: M });
  }, []);
  xe(() => {
    if (!u) return;
    const i = /* @__PURE__ */ new Date(u + "T00:00:00");
    O(i.getFullYear()), C(i.getMonth());
  }, [u]), xe(() => {
    if (!b) return;
    function i(h) {
      L.current && !L.current.contains(h.target) && A.current && !A.current.contains(h.target) && l(!1);
    }
    return document.addEventListener("mousedown", i), document.addEventListener("touchstart", i, { passive: !0 }), () => {
      document.removeEventListener("mousedown", i), document.removeEventListener("touchstart", i);
    };
  }, [b]), xe(() => {
    function i(h) {
      h.key === "Escape" && l(!1);
    }
    return b && document.addEventListener("keydown", i), () => document.removeEventListener("keydown", i);
  }, [b]), xe(() => {
    if (b)
      return Y(), window.addEventListener("scroll", Y, !0), window.addEventListener("resize", Y), () => {
        window.removeEventListener("scroll", Y, !0), window.removeEventListener("resize", Y);
      };
  }, [b, Y]);
  const j = /* @__PURE__ */ new Date(e + "T00:00:00"), te = /* @__PURE__ */ new Date(n + "T00:00:00"), J = new Date(g, v + 1, 0).getDate(), N = new Date(g, v, 1).getDay(), m = [];
  if (N > 0) {
    const i = new Date(g, v, 0).getDate();
    for (let h = N - 1; h >= 0; h--)
      m.push({ day: i - h, outside: !0 });
  }
  const X = [];
  for (let i = 1; i <= J; i++) {
    const h = g, d = String(v + 1).padStart(2, "0"), S = String(i).padStart(2, "0");
    X.push({ day: i, dateStr: `${h}-${d}-${S}`, outside: !1 });
  }
  const q = (7 - (m.length + X.length) % 7) % 7, re = [];
  for (let i = 1; i <= q; i++)
    re.push({ day: i, outside: !0 });
  const le = [...m, ...X, ...re];
  function ye(i) {
    const h = /* @__PURE__ */ new Date(i + "T00:00:00");
    return !(h < j || h > te || Ra(i, r, o));
  }
  function ce(i) {
    const h = /* @__PURE__ */ new Date(), d = h.getFullYear(), S = String(h.getMonth() + 1).padStart(2, "0"), M = String(h.getDate()).padStart(2, "0");
    return i === `${d}-${S}-${M}`;
  }
  function fe(i) {
    return u === i;
  }
  function z() {
    v === 0 ? (O((i) => i - 1), C(11)) : C((i) => i - 1);
  }
  function H() {
    v === 11 ? (O((i) => i + 1), C(0)) : C((i) => i + 1);
  }
  function K(i) {
    i.preventDefault(), z();
  }
  function y(i) {
    i.preventDefault(), H();
  }
  const U = u ? (() => {
    const i = /* @__PURE__ */ new Date(u + "T00:00:00");
    return `${Jt[i.getMonth()]} ${i.getDate()}, ${i.getFullYear()}`;
  })() : "Select date";
  function $(i) {
    if (i.outside)
      return /* @__PURE__ */ B.jsx("td", { className: "cal-day cal-day--empty" }, `p-${i.day}`);
    const h = ye(i.dateStr), d = ce(i.dateStr), S = fe(i.dateStr);
    let M = "cal-day";
    return d && (M += " cal-day--today"), S && (M += " cal-day--selected"), h || (M += " cal-day--disabled"), /* @__PURE__ */ B.jsx("td", { className: M, children: /* @__PURE__ */ B.jsx(
      "button",
      {
        type: "button",
        disabled: !h,
        onClick: () => {
          h && (f(i.dateStr), l(!1));
        },
        "aria-label": `${Jt[(/* @__PURE__ */ new Date(i.dateStr + "T00:00:00")).getMonth()]} ${(/* @__PURE__ */ new Date(i.dateStr + "T00:00:00")).getDate()}, ${(/* @__PURE__ */ new Date(i.dateStr + "T00:00:00")).getFullYear()}`,
        className: "cal-day-btn",
        children: i.day
      }
    ) }, i.dateStr);
  }
  return /* @__PURE__ */ B.jsxs("div", { className: "calendar-picker", children: [
    /* @__PURE__ */ B.jsxs(
      "button",
      {
        ref: A,
        type: "button",
        className: "cal-trigger",
        onClick: () => {
          b || Y(), l(!b);
        },
        "aria-haspopup": "dialog",
        "aria-expanded": b,
        children: [
          /* @__PURE__ */ B.jsx("span", { className: "cal-trigger-icon", "aria-hidden": "true", children: /* @__PURE__ */ B.jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
            /* @__PURE__ */ B.jsx("rect", { x: "1.5", y: "3", width: "13", height: "11.5", rx: "1.5", stroke: "currentColor", strokeWidth: "1.2" }),
            /* @__PURE__ */ B.jsx("path", { d: "M1.5 6.5h13", stroke: "currentColor", strokeWidth: "1.2" }),
            /* @__PURE__ */ B.jsx("path", { d: "M5 1.5v3M11 1.5v3", stroke: "currentColor", strokeWidth: "1.2", strokeLinecap: "round" })
          ] }) }),
          /* @__PURE__ */ B.jsx("span", { className: "cal-trigger-text", children: U })
        ]
      }
    ),
    b && nr(
      /* @__PURE__ */ B.jsxs("div", { className: "calendar-picker calendar-picker--portal", children: [
        /* @__PURE__ */ B.jsx("div", { className: "cal-backdrop", "aria-hidden": "true", onClick: () => l(!1) }),
        /* @__PURE__ */ B.jsxs(
          "div",
          {
            ref: L,
            className: "cal-picker",
            role: "dialog",
            "aria-label": "Select a date",
            style: E ? { top: E.top, left: E.left } : void 0,
            children: [
              /* @__PURE__ */ B.jsxs("div", { className: "cal-header", children: [
                /* @__PURE__ */ B.jsx("button", { type: "button", className: "cal-nav-btn cal-nav--prev", onClick: K, children: "‹" }),
                /* @__PURE__ */ B.jsxs("span", { className: "cal-month-year", children: [
                  Jt[v],
                  " ",
                  g
                ] }),
                /* @__PURE__ */ B.jsx("button", { type: "button", className: "cal-nav-btn cal-nav--next", onClick: y, children: "›" })
              ] }),
              /* @__PURE__ */ B.jsx("div", { className: "cal-weekdays", children: xa.map((i) => /* @__PURE__ */ B.jsx("div", { className: "cal-weekday", children: i }, i)) }),
              /* @__PURE__ */ B.jsx("table", { className: "cal-grid", children: /* @__PURE__ */ B.jsx("tbody", { children: (() => {
                const i = [];
                for (let h = 0; h < le.length; h += 7)
                  i.push(
                    /* @__PURE__ */ B.jsx("tr", { children: le.slice(h, h + 7).map($) }, h)
                  );
                return i;
              })() }) })
            ]
          }
        )
      ] }),
      document.body
    )
  ] });
}, Pa = "lib", Dn = {
  local: {
    host: "http://localhost:3000/"
  },
  dev: {
    host: "https://wl.waitlydev.com/"
  },
  prod: {
    host: "https://wl.waitly.com/"
  }
}, Rt = Dn[Pa] || Dn.dev, Ma = (e) => {
  const n = e.split("-");
  return n.length === 1 ? n[0] : n[0] + n.slice(1).map((r) => r[0].toUpperCase() + r.slice(1)).join("");
}, kn = (e) => {
  const n = {};
  return e && e.split(";").forEach((r) => {
    const [o, u] = r.split(":");
    if (!o) return;
    const f = Ma(o.trim());
    n[f] = u.trim();
  }), n;
};
function He(e, n) {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: n,
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).format(new Date(e));
}
function Nn(e, n) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: n,
    hour: "2-digit",
    minute: "2-digit",
    hour12: !1
  }).format(new Date(e));
}
function Xn(e) {
  const [n, r] = e.split(":"), o = Number(n), u = Number(r), f = o >= 12 ? "PM" : "AM";
  return `${o % 12 === 0 ? 12 : o % 12}:${String(u).padStart(2, "0")} ${f}`;
}
function Aa(e, n, r) {
  const [o, u] = e.split(":").map(Number), [f, b] = n.split(":").map(Number);
  let l = o * 60 + u;
  const g = f === 0 && b === 0 ? 24 * 60 : f * 60 + b;
  if (r) {
    const [v, C] = r.split(":").map(Number), E = v * 60 + C;
    E > l && (l = Math.ceil(E / 15) * 15);
  }
  const O = [];
  for (let v = l; v < g; v += 15) {
    const C = Math.floor(v / 60), E = v % 60, D = `${String(C).padStart(2, "0")}:${String(E).padStart(2, "0")}`;
    O.push({ value: D, label: Xn(D) });
  }
  return O;
}
function ja(e, n, r) {
  if (e != null && e.length)
    return e.find((o) => He(o.date, r) === n);
}
function Da(e) {
  return (/* @__PURE__ */ new Date(e + "T00:00:00")).getDay();
}
function Zn(e, n) {
  const r = /* @__PURE__ */ new Date(e + "T00:00:00");
  r.setDate(r.getDate() + n);
  const o = r.getFullYear(), u = String(r.getMonth() + 1).padStart(2, "0"), f = String(r.getDate()).padStart(2, "0");
  return `${o}-${u}-${f}`;
}
function $n(e) {
  return Zn(e, 1);
}
function on(e, n) {
  var O;
  const r = ja(e.shifts, n, e.timezone);
  let o, u;
  if (r) {
    if (r.closed || !r.begin || !r.end) return [];
    o = r.begin, u = r.end;
  } else {
    const v = (O = e.hours) == null ? void 0 : O[Da(n)];
    if (!v || v.closed || !v.begin || !v.end) return [];
    o = v.begin, u = v.end;
  }
  const f = He(e.minDate, e.timezone), b = He(e.maxDate, e.timezone), l = n === f ? Nn(e.minDate, e.timezone) : void 0, g = Aa(o, u, l);
  if (n === b) {
    const v = Nn(e.maxDate, e.timezone);
    return g.filter((C) => C.value <= v);
  }
  return g;
}
function ka(e, n) {
  const r = He(e.maxDate, e.timezone);
  let o = $n(n);
  for (; o <= r; ) {
    if (on(e, o).length > 0) return o;
    o = $n(o);
  }
  return null;
}
function Gt() {
  const e = /* @__PURE__ */ new Date(), n = e.getFullYear(), r = String(e.getMonth() + 1).padStart(2, "0"), o = String(e.getDate()).padStart(2, "0");
  return `${n}-${r}-${o}`;
}
const Na = (() => {
  const e = [];
  for (let n = 10 * 60; n <= 22 * 60; n += 30) {
    const r = Math.floor(n / 60), o = n % 60, u = `${String(r).padStart(2, "0")}:${String(o).padStart(2, "0")}`;
    e.push({ value: u, label: Xn(u) });
  }
  return e;
})(), Ia = ({
  type: e,
  bid: n,
  mode: r,
  title: o,
  buttonClass: u,
  style: f,
  host: b,
  minPartySize: l,
  maxPartySize: g
}) => {
  const O = { border: "0px", display: "none", width: "100%", height: "100%" }, v = { border: "0px", width: "100%", height: "100%" }, [C, E] = ke(!1), [D, L] = ke(!0), [A, Y] = ke(O), [j, te] = ke(null), J = Number(l || 1), N = Number(g || 10), m = Math.max(J, (j == null ? void 0 : j.minPartySize) || 1), X = j != null && j.maxPartySize && j.maxPartySize > 0 ? Math.min(N, j.maxPartySize) : N, G = pn(() => {
    const $ = m, i = Math.max(X, $);
    return Array.from(Array(i - $ + 1).keys()).map((h) => {
      const d = h + $;
      return { label: `${d} ${d === 1 ? "person" : "people"}`, value: d };
    });
  }, [m, X]), [q, re] = ke({
    date: Gt(),
    time: void 0,
    partySize: J
  });
  xe(() => {
    jn.setAppElement(document.body);
  }, []), xe(() => {
    if (e !== "resForm" || !n) return;
    let $ = !1;
    const i = b || Rt.host;
    return fetch(`${i}waitlist/api/widget/businessSummary?id=${encodeURIComponent(n)}`).then((h) => {
      if (!h.ok) throw new Error(`HTTP ${h.status}`);
      return h.json();
    }).then((h) => {
      if ($) return;
      te(h);
      const d = He(h.minDate, h.timezone);
      re((S) => ({ ...S, date: d }));
    }).catch((h) => {
      $ || console.warn("[waitly-widget] businessSummary fetch failed:", h);
    }), () => {
      $ = !0;
    };
  }, [e, n, b]);
  const le = pn(() => j ? q.date ? on(j, q.date) : [] : Na, [j, q.date]);
  xe(() => {
    if (!le.length) {
      q.time !== void 0 && re(($) => ({ ...$, time: void 0 }));
      return;
    }
    (!q.time || !le.some(($) => $.value === q.time)) && re(($) => ({ ...$, time: le[0].value }));
  }, [le, q.time]), xe(() => {
    G.length && (G.some(($) => $.value === q.partySize) || re(($) => ({ ...$, partySize: G[0].value })));
  }, [G, q.partySize]), xe(() => {
    if (!j || on(j, q.date).length > 0) return;
    const $ = ka(j, q.date);
    $ && $ !== q.date && re((i) => ({ ...i, date: $ }));
  }, [j, q.date]);
  const ye = {
    waitlist: {
      url: `${b || Rt.host}checkin/${n}`,
      buttonText: "Add me to Waitlist"
    },
    resButton: {
      url: `${b || Rt.host}book/${n}`,
      buttonText: "Make Reservation"
    },
    resForm: {
      url: `${b || Rt.host}book/${n}`,
      buttonText: "Make a Reservation"
    }
  };
  xe(() => {
    const $ = (i) => {
      i.data && i.data.source && i.data.source === "waitly" && (i.data.command === "dismiss" ? (E(!1), K()) : i.data.command === "loadingComplete" && z());
    };
    return window.addEventListener("message", $), () => window.removeEventListener("message", $);
  }, []);
  const ce = ($) => {
    $ == null || $.preventDefault(), $ == null || $.stopPropagation(), n && (r === "tab" ? window.open(
      `${ye[e].url}?title=${o || ye[e].buttonText}${e === "resForm" ? `&prepopulate=true&date=${encodeURI(q.date)}&time=${encodeURI(q.time || "")}&partySize=${q.partySize}` : ""}`,
      "new"
    ) : (E(!0), L(!0)));
  }, fe = () => {
    E(!1), K();
  }, z = () => {
    L(!1), H();
  }, H = () => Y(v), K = () => Y(O);
  xe(() => {
    e === "resForm" && L(!0);
  }, [e]);
  const y = j ? He(j.minDate, j.timezone) : Gt(), U = j ? He(j.maxDate, j.timezone) : Zn(Gt(), 90);
  return /* @__PURE__ */ B.jsxs("div", { children: [
    e === "resForm" ? /* @__PURE__ */ B.jsxs("div", { className: "res-form-container", children: [
      /* @__PURE__ */ B.jsx("div", { className: "res-form-title", children: o }),
      /* @__PURE__ */ B.jsxs("div", { className: "res-form-date-time-container", children: [
        /* @__PURE__ */ B.jsx(
          _a,
          {
            minDate: y,
            maxDate: U,
            businessHours: j == null ? void 0 : j.hours,
            shifts: j == null ? void 0 : j.shifts,
            timezone: j == null ? void 0 : j.timezone,
            selectedDate: q.date,
            onSelectDate: ($) => re((i) => ({ ...i, date: $ }))
          }
        ),
        /* @__PURE__ */ B.jsxs(
          "select",
          {
            name: "time",
            className: "res-form-input",
            value: q.time || "",
            onChange: ($) => re((i) => ({ ...i, time: $.target.value })),
            disabled: !le.length,
            children: [
              le.length === 0 && /* @__PURE__ */ B.jsx("option", { value: "", children: "No times available" }),
              le.map(($, i) => /* @__PURE__ */ B.jsx("option", { value: $.value, children: $.label }, "t" + i))
            ]
          }
        )
      ] }),
      !(j != null && j.hidePartySize) && G.length > 1 && /* @__PURE__ */ B.jsx(
        "select",
        {
          name: "partySize",
          className: "res-form-input",
          value: q.partySize,
          onChange: ($) => re((i) => ({ ...i, partySize: Number($.target.value) })),
          children: G.map(($, i) => /* @__PURE__ */ B.jsx("option", { value: $.value, children: $.label }, "pz" + i))
        }
      ),
      /* @__PURE__ */ B.jsx(
        "button",
        {
          onClick: ce,
          className: u,
          style: kn(f),
          type: "button",
          disabled: !q.time,
          children: "Find a time"
        }
      )
    ] }) : /* @__PURE__ */ B.jsx(
      "button",
      {
        onClick: ce,
        className: u,
        style: kn(f),
        type: "button",
        id: "waitly-waitlist-widget-button",
        children: o || ye[e].buttonText
      }
    ),
    /* @__PURE__ */ B.jsx(
      jn,
      {
        shouldCloseOnOverlayClick: !1,
        shouldCloseOnEsc: !1,
        isOpen: C,
        preventScroll: !0,
        className: "Modal",
        overlayClassName: "Overlay",
        onRequestClose: fe,
        children: /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
          D && /* @__PURE__ */ B.jsx(Ta, {}),
          /* @__PURE__ */ B.jsx(
            "iframe",
            {
              title: "Waitlist Check-in",
              allowtransparency: "true",
              style: A,
              src: `${ye[e].url}?widget=true&title=${o || ye[e].buttonText}${e === "resForm" ? `&prepopulate=true&date=${encodeURI(q.date)}&time=${encodeURI(q.time || "")}&partySize=${q.partySize}` : ""}`
            }
          )
        ] })
      }
    )
  ] });
};
export {
  Ia as Widget
};
//# sourceMappingURL=waitly-widgets.es.js.map
